/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Swipe4Work Employer API
 * OpenAPI spec version: 0.1.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  AddOrUpdateDefaultMessageCommandDto,
  AddUserCommentCommandDto,
  BuyCreditsCommandDto,
  CloseJobCommandDto,
  CloseMatchCommandDto,
  ConvertLeadCompanyToCustomerCommandDto,
  CreateCompanyForEmployerCommandDto,
  CreateCompanyHireReportCommandDto,
  CreateEmployerCommandDto,
  CreateEmployerInviteCommandDto,
  CreateFirebaseAccountForLeadCommandDto,
  CreateJobCommandDto,
  CreateTeammateInviteCommandDto,
  DeleteEmployerCommandDto,
  EditUserCommentCommandDto,
  GetAutoCompleteLocationsParams,
  GetEmployerOnboardingStatusParams,
  GetLocationDetailsParams,
  GetLocationGeocodeParams,
  GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets,
  GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets,
  ListAllMatchesParams,
  ListAllWaitingJobApplicationsParams,
  ListConferenceChatsEmployerParams,
  ListJobApplicationsForJobParams,
  ListJobsParams,
  ListMatchesForJobParams,
  ListSkillsForInterestsParams,
  ListSkillsForJobCategoriesParams,
  ListUnhandledJobsParams,
  ListUnhandledMatchesParams,
  ListUnreadConferenceChatsEmployerParams,
  MapJobWithAtsJobCommandDto,
  MarkMatchCommandDto,
  ReactToCandidateCommandDto,
  RejectJobApplicationCommandDto,
  SendCompleteProfileRequestCommandDto,
  SendMessageCommandDto,
  SendPollCommandDto,
  SendRequestToAccountManagerCommandDto,
  SetCompanyMatchingConfigurationCommandDto,
  StartMatchCommandDto,
  UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig,
  UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig,
  UpdateCompanyFromPortalCommandDto,
  UpdateEmployerProfileCommandDto,
  UpdateJobCommandDto,
  UpdateJobNotificationSettingsCommandDto,
  UpdateJobPublishedCommandDto,
  UploadProvisionalImageBody
} from './models';

import {
  faker
} from '@faker-js/faker';

import {
  HttpResponse,
  delay,
  http
} from 'msw';
import type {
  RequestHandlerOptions
} from 'msw';

import {
  AtsJobMappingStatus,
  CharacteristicColor,
  ChatMessageSenderRole,
  ConnectionStatus,
  DefaultMessageType,
  EmployerInviteType,
  EmployerMatchClosureReason,
  EmployerOnboardingStatus,
  EmployerRole,
  FeatureImportance,
  IntegrationType,
  IntegrationVisibility,
  InvoiceStatus,
  JobApplicationState,
  JobClosureReason,
  JobStatus,
  Periodicity,
  PermissionLevel,
  PermissionResource,
  ReportingPeriodicity,
  Role,
  SkillType,
  SubscriptionStatus,
  TrackCategory,
  WorkExperienceType
} from './models';
import type {
  AddOrUpdateDefaultMessageResult,
  ChatMessageDto,
  CreateCompanyHireReport,
  CreateEmployerResponse,
  CreateFirebaseAccountForLeadResult,
  DeleteDefaultMessageResult,
  FindBestCandidateResult,
  GetAtsIntegrationConnectionResultHomerunConnectionConfig,
  GetAtsIntegrationConnectionResultRecruiteeConnectionConfig,
  GetAutoCompleteLocationsResult,
  GetCompanyFromPortalResult,
  GetCompanyHireReportInfoResult,
  GetCompanyMatchingConfigurationResult,
  GetCompanyPlanResult,
  GetCompanyStatisticsResult,
  GetConferenceChatWithMessagesForEmployerResult,
  GetConferenceInfoResult,
  GetEmployerAccessResult,
  GetEmployerOnboardingStatusResult,
  GetEmployerProfileResult,
  GetInvoiceFileUrlResult,
  GetJobApplicationResult,
  GetJobNotificationSettingsResult,
  GetJobResult,
  GetLeadEmployerResult,
  GetLocationDetailsResult,
  GetLocationGeocodeResult,
  GetMatchChatWithMessagesResult,
  GetMatchedUserResult,
  GetRoleResult,
  GetSubscriptionResult,
  GetUserCommentsResult,
  ImageDto,
  IntegrationConnectionDto,
  JobCategoryCrudJobCategoryDto,
  JobCategoryCrudListResult,
  JobFunctionCrudJobFunctionDto,
  JobFunctionCrudListResult,
  ListAllSkillsResult,
  ListAllWaitingJobApplicationsResult,
  ListAtsJobsResult,
  ListCompanySubscriptionsResult,
  ListConferenceChatsResult,
  ListCreditTransactionsResult,
  ListEducationLevelsResult,
  ListEducationLevelsWithTrackCategoryResult,
  ListIntegrationsResult,
  ListInterestsResult,
  ListInvoicesForCompanyResult,
  ListJobApplicationRejectionReasonsResult,
  ListJobApplicationsForJobResult,
  ListJobsInPortalResult,
  ListManagedCompaniesResult,
  ListMatchesForJobResult,
  ListMatchesResult,
  ListNewJobReasonsResult,
  ListOtherEmployersForCompanyResult,
  ListPaymentOptionsResult,
  ListPersonalCharacteristicsResult,
  ListPersonalityTypesResult,
  ListReferralInvitesResult,
  ListSkillsForInterestsResult,
  ListSkillsForJobCategoriesResult,
  ListUnhandledJobsResult,
  ListUnhandledMatchesResult,
  ListUnreadConferenceChatsResult,
  ReactToCandidateResult,
  RejectJobApplicationResult,
  SendPollResult,
  StartMatchResult,
  Unit,
  UpdateJobPublishedResult
} from './models';

import { fetchWithAuth } from '../../../src/modules/orval/fetch-with-auth';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Add a new internal comment about a user (candidate).
 */
export const getAddUserCommentUrl = () => {


  

  return `/v1/employer/user/comments`
}

export const addUserComment = async (addUserCommentCommandDto: AddUserCommentCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getAddUserCommentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addUserCommentCommandDto,)
  }
);}




export const getAddUserCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addUserComment>>, TError,{data: AddUserCommentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof addUserComment>>, TError,{data: AddUserCommentCommandDto}, TContext> => {

const mutationKey = ['addUserComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addUserComment>>, {data: AddUserCommentCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  addUserComment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddUserCommentMutationResult = NonNullable<Awaited<ReturnType<typeof addUserComment>>>
    export type AddUserCommentMutationBody = AddUserCommentCommandDto
    export type AddUserCommentMutationError = unknown

    /**
 * @summary Add a new internal comment about a user (candidate).
 */
export const useAddUserComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addUserComment>>, TError,{data: AddUserCommentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addUserComment>>,
        TError,
        {data: AddUserCommentCommandDto},
        TContext
      > => {

      const mutationOptions = getAddUserCommentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get all comments for a user (candidate) visible to the current employer's company.
 */
export const getGetUserCommentsUrl = (userId: number,) => {


  

  return `/v1/employer/user/comments/${userId}`
}

export const getUserComments = async (userId: number, options?: RequestInit): Promise<GetUserCommentsResult> => {
  
  return fetchWithAuth<GetUserCommentsResult>(getGetUserCommentsUrl(userId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserCommentsQueryKey = (userId?: MaybeRef<number>,) => {
    return [
    'v1','employer','user','comments',userId
    ] as const;
    }

    
export const getGetUserCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getUserComments>>, TError = unknown>(userId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserComments>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetUserCommentsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserComments>>> = ({ signal }) => getUserComments(unref(userId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(userId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserComments>>, TError, TData> 
}

export type GetUserCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserComments>>>
export type GetUserCommentsQueryError = unknown


/**
 * @summary Get all comments for a user (candidate) visible to the current employer's company.
 */

export function useGetUserComments<TData = Awaited<ReturnType<typeof getUserComments>>, TError = unknown>(
 userId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserComments>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserCommentsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Edit an existing comment (only by the author).
 */
export const getEditUserCommentUrl = (commentId: number,) => {


  

  return `/v1/employer/user/comments/${commentId}`
}

export const editUserComment = async (commentId: number,
    editUserCommentCommandDto: EditUserCommentCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getEditUserCommentUrl(commentId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editUserCommentCommandDto,)
  }
);}




export const getEditUserCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserComment>>, TError,{commentId: number;data: EditUserCommentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof editUserComment>>, TError,{commentId: number;data: EditUserCommentCommandDto}, TContext> => {

const mutationKey = ['editUserComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUserComment>>, {commentId: number;data: EditUserCommentCommandDto}> = (props) => {
          const {commentId,data} = props ?? {};

          return  editUserComment(commentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditUserCommentMutationResult = NonNullable<Awaited<ReturnType<typeof editUserComment>>>
    export type EditUserCommentMutationBody = EditUserCommentCommandDto
    export type EditUserCommentMutationError = unknown

    /**
 * @summary Edit an existing comment (only by the author).
 */
export const useEditUserComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserComment>>, TError,{commentId: number;data: EditUserCommentCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof editUserComment>>,
        TError,
        {commentId: number;data: EditUserCommentCommandDto},
        TContext
      > => {

      const mutationOptions = getEditUserCommentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Soft-delete a comment (only by the author).
 */
export const getDeleteUserCommentUrl = (commentId: number,) => {


  

  return `/v1/employer/user/comments/${commentId}`
}

export const deleteUserComment = async (commentId: number, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getDeleteUserCommentUrl(commentId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteUserCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserComment>>, TError,{commentId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserComment>>, TError,{commentId: number}, TContext> => {

const mutationKey = ['deleteUserComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserComment>>, {commentId: number}> = (props) => {
          const {commentId} = props ?? {};

          return  deleteUserComment(commentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserCommentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserComment>>>
    
    export type DeleteUserCommentMutationError = unknown

    /**
 * @summary Soft-delete a comment (only by the author).
 */
export const useDeleteUserComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserComment>>, TError,{commentId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteUserComment>>,
        TError,
        {commentId: number},
        TContext
      > => {

      const mutationOptions = getDeleteUserCommentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getListAllSkillsUrl = () => {


  

  return `/skill/v2`
}

export const listAllSkills = async ( options?: RequestInit): Promise<ListAllSkillsResult> => {
  
  return fetchWithAuth<ListAllSkillsResult>(getListAllSkillsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListAllSkillsQueryKey = () => {
    return [
    'skill','v2'
    ] as const;
    }

    
export const getListAllSkillsQueryOptions = <TData = Awaited<ReturnType<typeof listAllSkills>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAllSkillsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllSkills>>> = ({ signal }) => listAllSkills({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData> 
}

export type ListAllSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllSkills>>>
export type ListAllSkillsQueryError = unknown



export function useListAllSkills<TData = Awaited<ReturnType<typeof listAllSkills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllSkills>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllSkillsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all education levels
 */
export const getListEducationLevelsWithTrackCategoryUrl = () => {


  

  return `/employer/static-data/education-levels`
}

export const listEducationLevelsWithTrackCategory = async ( options?: RequestInit): Promise<ListEducationLevelsWithTrackCategoryResult> => {
  
  return fetchWithAuth<ListEducationLevelsWithTrackCategoryResult>(getListEducationLevelsWithTrackCategoryUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListEducationLevelsWithTrackCategoryQueryKey = () => {
    return [
    'employer','static-data','education-levels'
    ] as const;
    }

    
export const getListEducationLevelsWithTrackCategoryQueryOptions = <TData = Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListEducationLevelsWithTrackCategoryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>> = ({ signal }) => listEducationLevelsWithTrackCategory({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError, TData> 
}

export type ListEducationLevelsWithTrackCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>>
export type ListEducationLevelsWithTrackCategoryQueryError = unknown


/**
 * @summary List all education levels
 */

export function useListEducationLevelsWithTrackCategory<TData = Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevelsWithTrackCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEducationLevelsWithTrackCategoryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getCreateCompanyForEmployerUrl = () => {


  

  return `/employer/employer-onboarding/create-company`
}

export const createCompanyForEmployer = async (createCompanyForEmployerCommandDto: CreateCompanyForEmployerCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getCreateCompanyForEmployerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCompanyForEmployerCommandDto,)
  }
);}




export const getCreateCompanyForEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyForEmployer>>, TError,{data: CreateCompanyForEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyForEmployer>>, TError,{data: CreateCompanyForEmployerCommandDto}, TContext> => {

const mutationKey = ['createCompanyForEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyForEmployer>>, {data: CreateCompanyForEmployerCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyForEmployer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyForEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyForEmployer>>>
    export type CreateCompanyForEmployerMutationBody = CreateCompanyForEmployerCommandDto
    export type CreateCompanyForEmployerMutationError = unknown

    export const useCreateCompanyForEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyForEmployer>>, TError,{data: CreateCompanyForEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCompanyForEmployer>>,
        TError,
        {data: CreateCompanyForEmployerCommandDto},
        TContext
      > => {

      const mutationOptions = getCreateCompanyForEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List Payment options.
Contains subscriptions and credit packages.
 */
export const getListPaymentOptionsUrl = () => {


  

  return `/employer/employer-onboarding/payment-options`
}

export const listPaymentOptions = async ( options?: RequestInit): Promise<ListPaymentOptionsResult> => {
  
  return fetchWithAuth<ListPaymentOptionsResult>(getListPaymentOptionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListPaymentOptionsQueryKey = () => {
    return [
    'employer','employer-onboarding','payment-options'
    ] as const;
    }

    
export const getListPaymentOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentOptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPaymentOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentOptions>>> = ({ signal }) => listPaymentOptions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPaymentOptions>>, TError, TData> 
}

export type ListPaymentOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentOptions>>>
export type ListPaymentOptionsQueryError = unknown


/**
 * @summary List Payment options.
Contains subscriptions and credit packages.
 */

export function useListPaymentOptions<TData = Awaited<ReturnType<typeof listPaymentOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPaymentOptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getCreateEmployerUrl = () => {


  

  return `/employer/v2/onboarding/register`
}

export const createEmployer = async (createEmployerCommandDto: CreateEmployerCommandDto, options?: RequestInit): Promise<CreateEmployerResponse> => {
  
  return fetchWithAuth<CreateEmployerResponse>(getCreateEmployerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEmployerCommandDto,)
  }
);}




export const getCreateEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: CreateEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: CreateEmployerCommandDto}, TContext> => {

const mutationKey = ['createEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployer>>, {data: CreateEmployerCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createEmployer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployer>>>
    export type CreateEmployerMutationBody = CreateEmployerCommandDto
    export type CreateEmployerMutationError = unknown

    export const useCreateEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: CreateEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createEmployer>>,
        TError,
        {data: CreateEmployerCommandDto},
        TContext
      > => {

      const mutationOptions = getCreateEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetEmployerOnboardingStatusUrl = (params?: GetEmployerOnboardingStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/v2/onboarding?${stringifiedParams}` : `/employer/v2/onboarding`
}

export const getEmployerOnboardingStatus = async (params?: GetEmployerOnboardingStatusParams, options?: RequestInit): Promise<GetEmployerOnboardingStatusResult> => {
  
  return fetchWithAuth<GetEmployerOnboardingStatusResult>(getGetEmployerOnboardingStatusUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployerOnboardingStatusQueryKey = (params?: MaybeRef<GetEmployerOnboardingStatusParams>,) => {
    return [
    'employer','v2','onboarding', ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmployerOnboardingStatusQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError = unknown>(params?: MaybeRef<GetEmployerOnboardingStatusParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetEmployerOnboardingStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>> = ({ signal }) => getEmployerOnboardingStatus(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError, TData> 
}

export type GetEmployerOnboardingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>>
export type GetEmployerOnboardingStatusQueryError = unknown



export function useGetEmployerOnboardingStatus<TData = Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError = unknown>(
 params?: MaybeRef<GetEmployerOnboardingStatusParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerOnboardingStatus>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerOnboardingStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all matches for the current company
 */
export const getListAllMatchesUrl = (params: ListAllMatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/match?${stringifiedParams}` : `/employer/match`
}

export const listAllMatches = async (params: ListAllMatchesParams, options?: RequestInit): Promise<ListMatchesResult> => {
  
  return fetchWithAuth<ListMatchesResult>(getListAllMatchesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListAllMatchesQueryKey = (params?: MaybeRef<ListAllMatchesParams>,) => {
    return [
    'employer','match', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListAllMatchesQueryOptions = <TData = Awaited<ReturnType<typeof listAllMatches>>, TError = unknown>(params: MaybeRef<ListAllMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAllMatchesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllMatches>>> = ({ signal }) => listAllMatches(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllMatches>>, TError, TData> 
}

export type ListAllMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listAllMatches>>>
export type ListAllMatchesQueryError = unknown


/**
 * @summary List all matches for the current company
 */

export function useListAllMatches<TData = Awaited<ReturnType<typeof listAllMatches>>, TError = unknown>(
 params: MaybeRef<ListAllMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllMatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetMatchedUserUrl = (id: number,) => {


  

  return `/employer/match/${id}/user`
}

export const getMatchedUser = async (id: number, options?: RequestInit): Promise<GetMatchedUserResult> => {
  
  return fetchWithAuth<GetMatchedUserResult>(getGetMatchedUserUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMatchedUserQueryKey = (id?: MaybeRef<number>,) => {
    return [
    'employer','match',id,'user'
    ] as const;
    }

    
export const getGetMatchedUserQueryOptions = <TData = Awaited<ReturnType<typeof getMatchedUser>>, TError = unknown>(id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchedUser>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchedUserQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchedUser>>> = ({ signal }) => getMatchedUser(unref(id), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchedUser>>, TError, TData> 
}

export type GetMatchedUserQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchedUser>>>
export type GetMatchedUserQueryError = unknown



export function useGetMatchedUser<TData = Awaited<ReturnType<typeof getMatchedUser>>, TError = unknown>(
 id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchedUser>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchedUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getMarkMatchAsReadOrUnreadUrl = () => {


  

  return `/employer/match/mark`
}

export const markMatchAsReadOrUnread = async (markMatchCommandDto: MarkMatchCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getMarkMatchAsReadOrUnreadUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      markMatchCommandDto,)
  }
);}




export const getMarkMatchAsReadOrUnreadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMatchAsReadOrUnread>>, TError,{data: MarkMatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof markMatchAsReadOrUnread>>, TError,{data: MarkMatchCommandDto}, TContext> => {

const mutationKey = ['markMatchAsReadOrUnread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markMatchAsReadOrUnread>>, {data: MarkMatchCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  markMatchAsReadOrUnread(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkMatchAsReadOrUnreadMutationResult = NonNullable<Awaited<ReturnType<typeof markMatchAsReadOrUnread>>>
    export type MarkMatchAsReadOrUnreadMutationBody = MarkMatchCommandDto
    export type MarkMatchAsReadOrUnreadMutationError = unknown

    export const useMarkMatchAsReadOrUnread = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMatchAsReadOrUnread>>, TError,{data: MarkMatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof markMatchAsReadOrUnread>>,
        TError,
        {data: MarkMatchCommandDto},
        TContext
      > => {

      const mutationOptions = getMarkMatchAsReadOrUnreadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getCloseMatchUrl = () => {


  

  return `/employer/match/close`
}

export const closeMatch = async (closeMatchCommandDto: CloseMatchCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getCloseMatchUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      closeMatchCommandDto,)
  }
);}




export const getCloseMatchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeMatch>>, TError,{data: CloseMatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof closeMatch>>, TError,{data: CloseMatchCommandDto}, TContext> => {

const mutationKey = ['closeMatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeMatch>>, {data: CloseMatchCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  closeMatch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloseMatchMutationResult = NonNullable<Awaited<ReturnType<typeof closeMatch>>>
    export type CloseMatchMutationBody = CloseMatchCommandDto
    export type CloseMatchMutationError = unknown

    export const useCloseMatch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeMatch>>, TError,{data: CloseMatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof closeMatch>>,
        TError,
        {data: CloseMatchCommandDto},
        TContext
      > => {

      const mutationOptions = getCloseMatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetMatchChatWithMessagesForEmployerUrl = (id: number,) => {


  

  return `/employer/match/${id}/chat`
}

export const getMatchChatWithMessagesForEmployer = async (id: number, options?: RequestInit): Promise<GetMatchChatWithMessagesResult> => {
  
  return fetchWithAuth<GetMatchChatWithMessagesResult>(getGetMatchChatWithMessagesForEmployerUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMatchChatWithMessagesForEmployerQueryKey = (id?: MaybeRef<number>,) => {
    return [
    'employer','match',id,'chat'
    ] as const;
    }

    
export const getGetMatchChatWithMessagesForEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError = unknown>(id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchChatWithMessagesForEmployerQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>> = ({ signal }) => getMatchChatWithMessagesForEmployer(unref(id), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError, TData> 
}

export type GetMatchChatWithMessagesForEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>>
export type GetMatchChatWithMessagesForEmployerQueryError = unknown



export function useGetMatchChatWithMessagesForEmployer<TData = Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError = unknown>(
 id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchChatWithMessagesForEmployerQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getSendMatchChatMessageForEmployerUrl = () => {


  

  return `/employer/match/chat`
}

export const sendMatchChatMessageForEmployer = async (sendMessageCommandDto: SendMessageCommandDto, options?: RequestInit): Promise<ChatMessageDto> => {
  
  return fetchWithAuth<ChatMessageDto>(getSendMatchChatMessageForEmployerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendMessageCommandDto,)
  }
);}




export const getSendMatchChatMessageForEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, TError,{data: SendMessageCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, TError,{data: SendMessageCommandDto}, TContext> => {

const mutationKey = ['sendMatchChatMessageForEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, {data: SendMessageCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  sendMatchChatMessageForEmployer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMatchChatMessageForEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>>
    export type SendMatchChatMessageForEmployerMutationBody = SendMessageCommandDto
    export type SendMatchChatMessageForEmployerMutationError = unknown

    export const useSendMatchChatMessageForEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>, TError,{data: SendMessageCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendMatchChatMessageForEmployer>>,
        TError,
        {data: SendMessageCommandDto},
        TContext
      > => {

      const mutationOptions = getSendMatchChatMessageForEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSendPollUrl = () => {


  

  return `/employer/match/poll`
}

export const sendPoll = async (sendPollCommandDto: SendPollCommandDto, options?: RequestInit): Promise<SendPollResult> => {
  
  return fetchWithAuth<SendPollResult>(getSendPollUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendPollCommandDto,)
  }
);}




export const getSendPollMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPoll>>, TError,{data: SendPollCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPoll>>, TError,{data: SendPollCommandDto}, TContext> => {

const mutationKey = ['sendPoll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPoll>>, {data: SendPollCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  sendPoll(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPollMutationResult = NonNullable<Awaited<ReturnType<typeof sendPoll>>>
    export type SendPollMutationBody = SendPollCommandDto
    export type SendPollMutationError = unknown

    export const useSendPoll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPoll>>, TError,{data: SendPollCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendPoll>>,
        TError,
        {data: SendPollCommandDto},
        TContext
      > => {

      const mutationOptions = getSendPollMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetLeadEmployerUrl = () => {


  

  return `/employer/lead/account`
}

export const getLeadEmployer = async ( options?: RequestInit): Promise<GetLeadEmployerResult> => {
  
  return fetchWithAuth<GetLeadEmployerResult>(getGetLeadEmployerUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetLeadEmployerQueryKey = () => {
    return [
    'employer','lead','account'
    ] as const;
    }

    
export const getGetLeadEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getLeadEmployer>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLeadEmployerQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadEmployer>>> = ({ signal }) => getLeadEmployer({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeadEmployer>>, TError, TData> 
}

export type GetLeadEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getLeadEmployer>>>
export type GetLeadEmployerQueryError = unknown



export function useGetLeadEmployer<TData = Awaited<ReturnType<typeof getLeadEmployer>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeadEmployerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getCreateFirebaseAccountForLeadUrl = () => {


  

  return `/employer/lead/account`
}

export const createFirebaseAccountForLead = async (createFirebaseAccountForLeadCommandDto: CreateFirebaseAccountForLeadCommandDto, options?: RequestInit): Promise<CreateFirebaseAccountForLeadResult> => {
  
  return fetchWithAuth<CreateFirebaseAccountForLeadResult>(getCreateFirebaseAccountForLeadUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createFirebaseAccountForLeadCommandDto,)
  }
);}




export const getCreateFirebaseAccountForLeadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, TError,{data: CreateFirebaseAccountForLeadCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, TError,{data: CreateFirebaseAccountForLeadCommandDto}, TContext> => {

const mutationKey = ['createFirebaseAccountForLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, {data: CreateFirebaseAccountForLeadCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createFirebaseAccountForLead(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFirebaseAccountForLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createFirebaseAccountForLead>>>
    export type CreateFirebaseAccountForLeadMutationBody = CreateFirebaseAccountForLeadCommandDto
    export type CreateFirebaseAccountForLeadMutationError = unknown

    export const useCreateFirebaseAccountForLead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFirebaseAccountForLead>>, TError,{data: CreateFirebaseAccountForLeadCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFirebaseAccountForLead>>,
        TError,
        {data: CreateFirebaseAccountForLeadCommandDto},
        TContext
      > => {

      const mutationOptions = getCreateFirebaseAccountForLeadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getConvertLeadCompanyToRegularUrl = () => {


  

  return `/employer/lead/company`
}

export const convertLeadCompanyToRegular = async (convertLeadCompanyToCustomerCommandDto: ConvertLeadCompanyToCustomerCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getConvertLeadCompanyToRegularUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      convertLeadCompanyToCustomerCommandDto,)
  }
);}




export const getConvertLeadCompanyToRegularMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, TError,{data: ConvertLeadCompanyToCustomerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, TError,{data: ConvertLeadCompanyToCustomerCommandDto}, TContext> => {

const mutationKey = ['convertLeadCompanyToRegular'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, {data: ConvertLeadCompanyToCustomerCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  convertLeadCompanyToRegular(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConvertLeadCompanyToRegularMutationResult = NonNullable<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>>
    export type ConvertLeadCompanyToRegularMutationBody = ConvertLeadCompanyToCustomerCommandDto
    export type ConvertLeadCompanyToRegularMutationError = unknown

    export const useConvertLeadCompanyToRegular = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertLeadCompanyToRegular>>, TError,{data: ConvertLeadCompanyToCustomerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof convertLeadCompanyToRegular>>,
        TError,
        {data: ConvertLeadCompanyToCustomerCommandDto},
        TContext
      > => {

      const mutationOptions = getConvertLeadCompanyToRegularMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List all jobs for the current company
 */
export const getListJobsUrl = (params?: ListJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/job?${stringifiedParams}` : `/employer/job`
}

export const listJobs = async (params?: ListJobsParams, options?: RequestInit): Promise<ListJobsInPortalResult> => {
  
  return fetchWithAuth<ListJobsInPortalResult>(getListJobsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListJobsQueryKey = (params?: MaybeRef<ListJobsParams>,) => {
    return [
    'employer','job', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListJobsQueryOptions = <TData = Awaited<ReturnType<typeof listJobs>>, TError = unknown>(params?: MaybeRef<ListJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobs>>> = ({ signal }) => listJobs(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData> 
}

export type ListJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobs>>>
export type ListJobsQueryError = unknown


/**
 * @summary List all jobs for the current company
 */

export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = unknown>(
 params?: MaybeRef<ListJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create a Job post
 */
export const getCreateJobUrl = () => {


  

  return `/employer/job`
}

export const createJob = async (createJobCommandDto: CreateJobCommandDto, options?: RequestInit): Promise<number> => {
  
  return fetchWithAuth<number>(getCreateJobUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createJobCommandDto,)
  }
);}




export const getCreateJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: CreateJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: CreateJobCommandDto}, TContext> => {

const mutationKey = ['createJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJob>>, {data: CreateJobCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateJobMutationResult = NonNullable<Awaited<ReturnType<typeof createJob>>>
    export type CreateJobMutationBody = CreateJobCommandDto
    export type CreateJobMutationError = unknown

    /**
 * @summary Create a Job post
 */
export const useCreateJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: CreateJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createJob>>,
        TError,
        {data: CreateJobCommandDto},
        TContext
      > => {

      const mutationOptions = getCreateJobMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a job
 */
export const getUpdateJobUrl = () => {


  

  return `/employer/job`
}

export const updateJob = async (updateJobCommandDto: UpdateJobCommandDto, options?: RequestInit): Promise<number> => {
  
  return fetchWithAuth<number>(getUpdateJobUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateJobCommandDto,)
  }
);}




export const getUpdateJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{data: UpdateJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{data: UpdateJobCommandDto}, TContext> => {

const mutationKey = ['updateJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJob>>, {data: UpdateJobCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  updateJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobMutationResult = NonNullable<Awaited<ReturnType<typeof updateJob>>>
    export type UpdateJobMutationBody = UpdateJobCommandDto
    export type UpdateJobMutationError = unknown

    /**
 * @summary Update a job
 */
export const useUpdateJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{data: UpdateJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJob>>,
        TError,
        {data: UpdateJobCommandDto},
        TContext
      > => {

      const mutationOptions = getUpdateJobMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetJobUrl = (id: number,) => {


  

  return `/employer/job/${id}`
}

export const getJob = async (id: number, options?: RequestInit): Promise<GetJobResult> => {
  
  return fetchWithAuth<GetJobResult>(getGetJobUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetJobQueryKey = (id?: MaybeRef<number>,) => {
    return [
    'employer','job',id
    ] as const;
    }

    
export const getGetJobQueryOptions = <TData = Awaited<ReturnType<typeof getJob>>, TError = unknown>(id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({ signal }) => getJob(unref(id), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> 
}

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>
export type GetJobQueryError = unknown



export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = unknown>(
 id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all job applications for a given job
 */
export const getListJobApplicationsForJobUrl = (jobId: number,
    params?: ListJobApplicationsForJobParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/job/${jobId}/job-applications?${stringifiedParams}` : `/employer/job/${jobId}/job-applications`
}

export const listJobApplicationsForJob = async (jobId: number,
    params?: ListJobApplicationsForJobParams, options?: RequestInit): Promise<ListJobApplicationsForJobResult> => {
  
  return fetchWithAuth<ListJobApplicationsForJobResult>(getListJobApplicationsForJobUrl(jobId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListJobApplicationsForJobQueryKey = (jobId?: MaybeRef<number>,
    params?: MaybeRef<ListJobApplicationsForJobParams>,) => {
    return [
    'employer','job',jobId,'job-applications', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListJobApplicationsForJobQueryOptions = <TData = Awaited<ReturnType<typeof listJobApplicationsForJob>>, TError = unknown>(jobId: MaybeRef<number>,
    params?: MaybeRef<ListJobApplicationsForJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationsForJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobApplicationsForJobQueryKey(jobId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobApplicationsForJob>>> = ({ signal }) => listJobApplicationsForJob(unref(jobId),unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(jobId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationsForJob>>, TError, TData> 
}

export type ListJobApplicationsForJobQueryResult = NonNullable<Awaited<ReturnType<typeof listJobApplicationsForJob>>>
export type ListJobApplicationsForJobQueryError = unknown


/**
 * @summary List all job applications for a given job
 */

export function useListJobApplicationsForJob<TData = Awaited<ReturnType<typeof listJobApplicationsForJob>>, TError = unknown>(
 jobId: MaybeRef<number>,
    params?: MaybeRef<ListJobApplicationsForJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationsForJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobApplicationsForJobQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List matches for a given job
 */
export const getListMatchesForJobUrl = (jobId: number,
    params: ListMatchesForJobParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/job/${jobId}/matches?${stringifiedParams}` : `/employer/job/${jobId}/matches`
}

export const listMatchesForJob = async (jobId: number,
    params: ListMatchesForJobParams, options?: RequestInit): Promise<ListMatchesForJobResult> => {
  
  return fetchWithAuth<ListMatchesForJobResult>(getListMatchesForJobUrl(jobId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListMatchesForJobQueryKey = (jobId?: MaybeRef<number>,
    params?: MaybeRef<ListMatchesForJobParams>,) => {
    return [
    'employer','job',jobId,'matches', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListMatchesForJobQueryOptions = <TData = Awaited<ReturnType<typeof listMatchesForJob>>, TError = unknown>(jobId: MaybeRef<number>,
    params: MaybeRef<ListMatchesForJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesForJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListMatchesForJobQueryKey(jobId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMatchesForJob>>> = ({ signal }) => listMatchesForJob(unref(jobId),unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(jobId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMatchesForJob>>, TError, TData> 
}

export type ListMatchesForJobQueryResult = NonNullable<Awaited<ReturnType<typeof listMatchesForJob>>>
export type ListMatchesForJobQueryError = unknown


/**
 * @summary List matches for a given job
 */

export function useListMatchesForJob<TData = Awaited<ReturnType<typeof listMatchesForJob>>, TError = unknown>(
 jobId: MaybeRef<number>,
    params: MaybeRef<ListMatchesForJobParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesForJob>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMatchesForJobQueryOptions(jobId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update the published status of a job
 */
export const getUpdateJobPublishedUrl = () => {


  

  return `/employer/job/update-published`
}

export const updateJobPublished = async (updateJobPublishedCommandDto: UpdateJobPublishedCommandDto, options?: RequestInit): Promise<UpdateJobPublishedResult> => {
  
  return fetchWithAuth<UpdateJobPublishedResult>(getUpdateJobPublishedUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateJobPublishedCommandDto,)
  }
);}




export const getUpdateJobPublishedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobPublished>>, TError,{data: UpdateJobPublishedCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobPublished>>, TError,{data: UpdateJobPublishedCommandDto}, TContext> => {

const mutationKey = ['updateJobPublished'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobPublished>>, {data: UpdateJobPublishedCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  updateJobPublished(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobPublishedMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobPublished>>>
    export type UpdateJobPublishedMutationBody = UpdateJobPublishedCommandDto
    export type UpdateJobPublishedMutationError = unknown

    /**
 * @summary Update the published status of a job
 */
export const useUpdateJobPublished = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobPublished>>, TError,{data: UpdateJobPublishedCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJobPublished>>,
        TError,
        {data: UpdateJobPublishedCommandDto},
        TContext
      > => {

      const mutationOptions = getUpdateJobPublishedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Close a Job, this will make it unavailable for new matches
 */
export const getCloseJobUrl = () => {


  

  return `/employer/job/close`
}

export const closeJob = async (closeJobCommandDto: CloseJobCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getCloseJobUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      closeJobCommandDto,)
  }
);}




export const getCloseJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,{data: CloseJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,{data: CloseJobCommandDto}, TContext> => {

const mutationKey = ['closeJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeJob>>, {data: CloseJobCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  closeJob(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloseJobMutationResult = NonNullable<Awaited<ReturnType<typeof closeJob>>>
    export type CloseJobMutationBody = CloseJobCommandDto
    export type CloseJobMutationError = unknown

    /**
 * @summary Close a Job, this will make it unavailable for new matches
 */
export const useCloseJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeJob>>, TError,{data: CloseJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof closeJob>>,
        TError,
        {data: CloseJobCommandDto},
        TContext
      > => {

      const mutationOptions = getCloseJobMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Find the best candidate for the specified job
 */
export const getFindBestCandidateUrl = (jobId: number,) => {


  

  return `/employer/job/${jobId}/find-best-candidate`
}

export const findBestCandidate = async (jobId: number, options?: RequestInit): Promise<FindBestCandidateResult> => {
  
  return fetchWithAuth<FindBestCandidateResult>(getFindBestCandidateUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getFindBestCandidateQueryKey = (jobId?: MaybeRef<number>,) => {
    return [
    'employer','job',jobId,'find-best-candidate'
    ] as const;
    }

    
export const getFindBestCandidateQueryOptions = <TData = Awaited<ReturnType<typeof findBestCandidate>>, TError = unknown>(jobId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findBestCandidate>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getFindBestCandidateQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findBestCandidate>>> = ({ signal }) => findBestCandidate(unref(jobId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(jobId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findBestCandidate>>, TError, TData> 
}

export type FindBestCandidateQueryResult = NonNullable<Awaited<ReturnType<typeof findBestCandidate>>>
export type FindBestCandidateQueryError = unknown


/**
 * @summary Find the best candidate for the specified job
 */

export function useFindBestCandidate<TData = Awaited<ReturnType<typeof findBestCandidate>>, TError = unknown>(
 jobId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findBestCandidate>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindBestCandidateQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary An employer reacts to the best found candidate.
The employee will get notified that the Employer is interested in the Employee's profile.
 */
export const getReactToBestCandidateUrl = () => {


  

  return `/employer/job/react-best-candidate`
}

export const reactToBestCandidate = async (reactToCandidateCommandDto: ReactToCandidateCommandDto, options?: RequestInit): Promise<ReactToCandidateResult> => {
  
  return fetchWithAuth<ReactToCandidateResult>(getReactToBestCandidateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reactToCandidateCommandDto,)
  }
);}




export const getReactToBestCandidateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactToBestCandidate>>, TError,{data: ReactToCandidateCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof reactToBestCandidate>>, TError,{data: ReactToCandidateCommandDto}, TContext> => {

const mutationKey = ['reactToBestCandidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactToBestCandidate>>, {data: ReactToCandidateCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  reactToBestCandidate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReactToBestCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof reactToBestCandidate>>>
    export type ReactToBestCandidateMutationBody = ReactToCandidateCommandDto
    export type ReactToBestCandidateMutationError = unknown

    /**
 * @summary An employer reacts to the best found candidate.
The employee will get notified that the Employer is interested in the Employee's profile.
 */
export const useReactToBestCandidate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactToBestCandidate>>, TError,{data: ReactToCandidateCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reactToBestCandidate>>,
        TError,
        {data: ReactToCandidateCommandDto},
        TContext
      > => {

      const mutationOptions = getReactToBestCandidateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get notification settings for a job, showing all teammates and their current subscription status
 */
export const getGetJobNotificationSettingsUrl = (jobId: number,) => {


  

  return `/employer/job/${jobId}/notification-settings`
}

export const getJobNotificationSettings = async (jobId: number, options?: RequestInit): Promise<GetJobNotificationSettingsResult> => {
  
  return fetchWithAuth<GetJobNotificationSettingsResult>(getGetJobNotificationSettingsUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetJobNotificationSettingsQueryKey = (jobId?: MaybeRef<number>,) => {
    return [
    'employer','job',jobId,'notification-settings'
    ] as const;
    }

    
export const getGetJobNotificationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getJobNotificationSettings>>, TError = unknown>(jobId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobNotificationSettingsQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobNotificationSettings>>> = ({ signal }) => getJobNotificationSettings(unref(jobId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(jobId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobNotificationSettings>>, TError, TData> 
}

export type GetJobNotificationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobNotificationSettings>>>
export type GetJobNotificationSettingsQueryError = unknown


/**
 * @summary Get notification settings for a job, showing all teammates and their current subscription status
 */

export function useGetJobNotificationSettings<TData = Awaited<ReturnType<typeof getJobNotificationSettings>>, TError = unknown>(
 jobId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobNotificationSettingsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update notification settings for a job, setting which teammates should receive notifications
 */
export const getUpdateJobNotificationSettingsUrl = () => {


  

  return `/employer/job/notification-settings`
}

export const updateJobNotificationSettings = async (updateJobNotificationSettingsCommandDto: UpdateJobNotificationSettingsCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getUpdateJobNotificationSettingsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateJobNotificationSettingsCommandDto,)
  }
);}




export const getUpdateJobNotificationSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobNotificationSettings>>, TError,{data: UpdateJobNotificationSettingsCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobNotificationSettings>>, TError,{data: UpdateJobNotificationSettingsCommandDto}, TContext> => {

const mutationKey = ['updateJobNotificationSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobNotificationSettings>>, {data: UpdateJobNotificationSettingsCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  updateJobNotificationSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobNotificationSettings>>>
    export type UpdateJobNotificationSettingsMutationBody = UpdateJobNotificationSettingsCommandDto
    export type UpdateJobNotificationSettingsMutationError = unknown

    /**
 * @summary Update notification settings for a job, setting which teammates should receive notifications
 */
export const useUpdateJobNotificationSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobNotificationSettings>>, TError,{data: UpdateJobNotificationSettingsCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateJobNotificationSettings>>,
        TError,
        {data: UpdateJobNotificationSettingsCommandDto},
        TContext
      > => {

      const mutationOptions = getUpdateJobNotificationSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get a specific job application
 */
export const getGetJobApplicationUrl = (jobApplicationId: number,) => {


  

  return `/employer/job-application/${jobApplicationId}`
}

export const getJobApplication = async (jobApplicationId: number, options?: RequestInit): Promise<GetJobApplicationResult> => {
  
  return fetchWithAuth<GetJobApplicationResult>(getGetJobApplicationUrl(jobApplicationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetJobApplicationQueryKey = (jobApplicationId?: MaybeRef<number>,) => {
    return [
    'employer','job-application',jobApplicationId
    ] as const;
    }

    
export const getGetJobApplicationQueryOptions = <TData = Awaited<ReturnType<typeof getJobApplication>>, TError = unknown>(jobApplicationId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobApplication>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobApplicationQueryKey(jobApplicationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobApplication>>> = ({ signal }) => getJobApplication(unref(jobApplicationId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(jobApplicationId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobApplication>>, TError, TData> 
}

export type GetJobApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof getJobApplication>>>
export type GetJobApplicationQueryError = unknown


/**
 * @summary Get a specific job application
 */

export function useGetJobApplication<TData = Awaited<ReturnType<typeof getJobApplication>>, TError = unknown>(
 jobApplicationId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobApplication>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobApplicationQueryOptions(jobApplicationId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all waiting job applications for the current company
 */
export const getListAllWaitingJobApplicationsUrl = (params?: ListAllWaitingJobApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/job-application?${stringifiedParams}` : `/employer/job-application`
}

export const listAllWaitingJobApplications = async (params?: ListAllWaitingJobApplicationsParams, options?: RequestInit): Promise<ListAllWaitingJobApplicationsResult> => {
  
  return fetchWithAuth<ListAllWaitingJobApplicationsResult>(getListAllWaitingJobApplicationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListAllWaitingJobApplicationsQueryKey = (params?: MaybeRef<ListAllWaitingJobApplicationsParams>,) => {
    return [
    'employer','job-application', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListAllWaitingJobApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listAllWaitingJobApplications>>, TError = unknown>(params?: MaybeRef<ListAllWaitingJobApplicationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllWaitingJobApplications>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAllWaitingJobApplicationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllWaitingJobApplications>>> = ({ signal }) => listAllWaitingJobApplications(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllWaitingJobApplications>>, TError, TData> 
}

export type ListAllWaitingJobApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllWaitingJobApplications>>>
export type ListAllWaitingJobApplicationsQueryError = unknown


/**
 * @summary List all waiting job applications for the current company
 */

export function useListAllWaitingJobApplications<TData = Awaited<ReturnType<typeof listAllWaitingJobApplications>>, TError = unknown>(
 params?: MaybeRef<ListAllWaitingJobApplicationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllWaitingJobApplications>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllWaitingJobApplicationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all rejection reasons for job applications of a company.
 */
export const getListJobApplicationRejectionReasonsUrl = () => {


  

  return `/employer/job-application/rejection-reasons`
}

export const listJobApplicationRejectionReasons = async ( options?: RequestInit): Promise<ListJobApplicationRejectionReasonsResult> => {
  
  return fetchWithAuth<ListJobApplicationRejectionReasonsResult>(getListJobApplicationRejectionReasonsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListJobApplicationRejectionReasonsQueryKey = () => {
    return [
    'employer','job-application','rejection-reasons'
    ] as const;
    }

    
export const getListJobApplicationRejectionReasonsQueryOptions = <TData = Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobApplicationRejectionReasonsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>> = ({ signal }) => listJobApplicationRejectionReasons({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError, TData> 
}

export type ListJobApplicationRejectionReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>>
export type ListJobApplicationRejectionReasonsQueryError = unknown


/**
 * @summary List all rejection reasons for job applications of a company.
 */

export function useListJobApplicationRejectionReasons<TData = Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobApplicationRejectionReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobApplicationRejectionReasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary An employer rejects a job application
 */
export const getRejectJobApplicationUrl = () => {


  

  return `/employer/job-application/reject`
}

export const rejectJobApplication = async (rejectJobApplicationCommandDto: RejectJobApplicationCommandDto, options?: RequestInit): Promise<RejectJobApplicationResult> => {
  
  return fetchWithAuth<RejectJobApplicationResult>(getRejectJobApplicationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      rejectJobApplicationCommandDto,)
  }
);}




export const getRejectJobApplicationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectJobApplication>>, TError,{data: RejectJobApplicationCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectJobApplication>>, TError,{data: RejectJobApplicationCommandDto}, TContext> => {

const mutationKey = ['rejectJobApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectJobApplication>>, {data: RejectJobApplicationCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  rejectJobApplication(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectJobApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectJobApplication>>>
    export type RejectJobApplicationMutationBody = RejectJobApplicationCommandDto
    export type RejectJobApplicationMutationError = unknown

    /**
 * @summary An employer rejects a job application
 */
export const useRejectJobApplication = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectJobApplication>>, TError,{data: RejectJobApplicationCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rejectJobApplication>>,
        TError,
        {data: RejectJobApplicationCommandDto},
        TContext
      > => {

      const mutationOptions = getRejectJobApplicationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary An employer starts a match for a job application
 */
export const getStartMatchUrl = () => {


  

  return `/employer/job-application/start-match`
}

export const startMatch = async (startMatchCommandDto: StartMatchCommandDto, options?: RequestInit): Promise<StartMatchResult> => {
  
  return fetchWithAuth<StartMatchResult>(getStartMatchUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startMatchCommandDto,)
  }
);}




export const getStartMatchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMatch>>, TError,{data: StartMatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof startMatch>>, TError,{data: StartMatchCommandDto}, TContext> => {

const mutationKey = ['startMatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMatch>>, {data: StartMatchCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  startMatch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartMatchMutationResult = NonNullable<Awaited<ReturnType<typeof startMatch>>>
    export type StartMatchMutationBody = StartMatchCommandDto
    export type StartMatchMutationError = unknown

    /**
 * @summary An employer starts a match for a job application
 */
export const useStartMatch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMatch>>, TError,{data: StartMatchCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof startMatch>>,
        TError,
        {data: StartMatchCommandDto},
        TContext
      > => {

      const mutationOptions = getStartMatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Send a Complete Profile Request to the anonymous user.
 */
export const getSendCompleteProfileRequestUrl = () => {


  

  return `/employer/job-application/complete-profile-request`
}

export const sendCompleteProfileRequest = async (sendCompleteProfileRequestCommandDto: SendCompleteProfileRequestCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getSendCompleteProfileRequestUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendCompleteProfileRequestCommandDto,)
  }
);}




export const getSendCompleteProfileRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, TError,{data: SendCompleteProfileRequestCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, TError,{data: SendCompleteProfileRequestCommandDto}, TContext> => {

const mutationKey = ['sendCompleteProfileRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, {data: SendCompleteProfileRequestCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  sendCompleteProfileRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCompleteProfileRequestMutationResult = NonNullable<Awaited<ReturnType<typeof sendCompleteProfileRequest>>>
    export type SendCompleteProfileRequestMutationBody = SendCompleteProfileRequestCommandDto
    export type SendCompleteProfileRequestMutationError = unknown

    /**
 * @summary Send a Complete Profile Request to the anonymous user.
 */
export const useSendCompleteProfileRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCompleteProfileRequest>>, TError,{data: SendCompleteProfileRequestCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendCompleteProfileRequest>>,
        TError,
        {data: SendCompleteProfileRequestCommandDto},
        TContext
      > => {

      const mutationOptions = getSendCompleteProfileRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getBuyCreditsUrl = () => {


  

  return `/employer/invoice/credits`
}

export const buyCredits = async (buyCreditsCommandDto: BuyCreditsCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getBuyCreditsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      buyCreditsCommandDto,)
  }
);}




export const getBuyCreditsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyCredits>>, TError,{data: BuyCreditsCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof buyCredits>>, TError,{data: BuyCreditsCommandDto}, TContext> => {

const mutationKey = ['buyCredits'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof buyCredits>>, {data: BuyCreditsCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  buyCredits(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BuyCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof buyCredits>>>
    export type BuyCreditsMutationBody = BuyCreditsCommandDto
    export type BuyCreditsMutationError = unknown

    export const useBuyCredits = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyCredits>>, TError,{data: BuyCreditsCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof buyCredits>>,
        TError,
        {data: BuyCreditsCommandDto},
        TContext
      > => {

      const mutationOptions = getBuyCreditsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getListCreditTransactionsUrl = () => {


  

  return `/employer/invoice/credits`
}

export const listCreditTransactions = async ( options?: RequestInit): Promise<ListCreditTransactionsResult> => {
  
  return fetchWithAuth<ListCreditTransactionsResult>(getListCreditTransactionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListCreditTransactionsQueryKey = () => {
    return [
    'employer','invoice','credits'
    ] as const;
    }

    
export const getListCreditTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listCreditTransactions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCreditTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCreditTransactionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCreditTransactions>>> = ({ signal }) => listCreditTransactions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCreditTransactions>>, TError, TData> 
}

export type ListCreditTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCreditTransactions>>>
export type ListCreditTransactionsQueryError = unknown



export function useListCreditTransactions<TData = Awaited<ReturnType<typeof listCreditTransactions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCreditTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCreditTransactionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetSubscriptionUrl = () => {


  

  return `/employer/invoice/subscription`
}

export const getSubscription = async ( options?: RequestInit): Promise<GetSubscriptionResult> => {
  
  return fetchWithAuth<GetSubscriptionResult>(getGetSubscriptionUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSubscriptionQueryKey = () => {
    return [
    'employer','invoice','subscription'
    ] as const;
    }

    
export const getGetSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetSubscriptionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscription>>> = ({ signal }) => getSubscription({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData> 
}

export type GetSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscription>>>
export type GetSubscriptionQueryError = unknown



export function useGetSubscription<TData = Awaited<ReturnType<typeof getSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscription>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListCompanySubscriptionsUrl = () => {


  

  return `/employer/invoice/subscriptions`
}

export const listCompanySubscriptions = async ( options?: RequestInit): Promise<ListCompanySubscriptionsResult> => {
  
  return fetchWithAuth<ListCompanySubscriptionsResult>(getListCompanySubscriptionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListCompanySubscriptionsQueryKey = () => {
    return [
    'employer','invoice','subscriptions'
    ] as const;
    }

    
export const getListCompanySubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listCompanySubscriptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanySubscriptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListCompanySubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanySubscriptions>>> = ({ signal }) => listCompanySubscriptions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanySubscriptions>>, TError, TData> 
}

export type ListCompanySubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanySubscriptions>>>
export type ListCompanySubscriptionsQueryError = unknown



export function useListCompanySubscriptions<TData = Awaited<ReturnType<typeof listCompanySubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompanySubscriptions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompanySubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListInvoicesForCompanyUrl = () => {


  

  return `/employer/invoice`
}

export const listInvoicesForCompany = async ( options?: RequestInit): Promise<ListInvoicesForCompanyResult> => {
  
  return fetchWithAuth<ListInvoicesForCompanyResult>(getListInvoicesForCompanyUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListInvoicesForCompanyQueryKey = () => {
    return [
    'employer','invoice'
    ] as const;
    }

    
export const getListInvoicesForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof listInvoicesForCompany>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoicesForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInvoicesForCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoicesForCompany>>> = ({ signal }) => listInvoicesForCompany({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoicesForCompany>>, TError, TData> 
}

export type ListInvoicesForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoicesForCompany>>>
export type ListInvoicesForCompanyQueryError = unknown



export function useListInvoicesForCompany<TData = Awaited<ReturnType<typeof listInvoicesForCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvoicesForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvoicesForCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetInvoiceFileUrlUrl = (fileId: string,) => {


  

  return `/employer/invoice/${fileId}`
}

export const getInvoiceFileUrl = async (fileId: string, options?: RequestInit): Promise<GetInvoiceFileUrlResult> => {
  
  return fetchWithAuth<GetInvoiceFileUrlResult>(getGetInvoiceFileUrlUrl(fileId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetInvoiceFileUrlQueryKey = (fileId?: MaybeRef<string>,) => {
    return [
    'employer','invoice',fileId
    ] as const;
    }

    
export const getGetInvoiceFileUrlQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError = unknown>(fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetInvoiceFileUrlQueryKey(fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceFileUrl>>> = ({ signal }) => getInvoiceFileUrl(unref(fileId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(fileId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError, TData> 
}

export type GetInvoiceFileUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceFileUrl>>>
export type GetInvoiceFileUrlQueryError = unknown



export function useGetInvoiceFileUrl<TData = Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError = unknown>(
 fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceFileUrl>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoiceFileUrlQueryOptions(fileId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListIntegrationsUrl = () => {


  

  return `/employer/integration`
}

export const listIntegrations = async ( options?: RequestInit): Promise<ListIntegrationsResult> => {
  
  return fetchWithAuth<ListIntegrationsResult>(getListIntegrationsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListIntegrationsQueryKey = () => {
    return [
    'employer','integration'
    ] as const;
    }

    
export const getListIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof listIntegrations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListIntegrationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIntegrations>>> = ({ signal }) => listIntegrations({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData> 
}

export type ListIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof listIntegrations>>>
export type ListIntegrationsQueryError = unknown



export function useListIntegrations<TData = Awaited<ReturnType<typeof listIntegrations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIntegrations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getConnectHomerunIntegrationUrl = () => {


  

  return `/employer/homerun-connection`
}

export const connectHomerunIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets, options?: RequestInit): Promise<IntegrationConnectionDto> => {
  
  return fetchWithAuth<IntegrationConnectionDto>(getConnectHomerunIntegrationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      getOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets,)
  }
);}




export const getConnectHomerunIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectHomerunIntegration>>, TError,{data: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectHomerunIntegration>>, TError,{data: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets}, TContext> => {

const mutationKey = ['connectHomerunIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectHomerunIntegration>>, {data: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets}> = (props) => {
          const {data} = props ?? {};

          return  connectHomerunIntegration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConnectHomerunIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectHomerunIntegration>>>
    export type ConnectHomerunIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets
    export type ConnectHomerunIntegrationMutationError = unknown

    export const useConnectHomerunIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectHomerunIntegration>>, TError,{data: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectHomerunIntegration>>,
        TError,
        {data: GetOrCreateAtsIntegrationConnectionCommandDtoHomerunConnectionSecrets},
        TContext
      > => {

      const mutationOptions = getConnectHomerunIntegrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getUpdateHomerunConnectionUrl = (connectionId: number,) => {


  

  return `/employer/homerun-connection/${connectionId}`
}

export const updateHomerunConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig, options?: RequestInit): Promise<Unit> => {
  
  return fetchWithAuth<Unit>(getUpdateHomerunConnectionUrl(connectionId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig,)
  }
);}




export const getUpdateHomerunConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHomerunConnection>>, TError,{connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHomerunConnection>>, TError,{connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig}, TContext> => {

const mutationKey = ['updateHomerunConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHomerunConnection>>, {connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateHomerunConnection(connectionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHomerunConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateHomerunConnection>>>
    export type UpdateHomerunConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig
    export type UpdateHomerunConnectionMutationError = unknown

    export const useUpdateHomerunConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHomerunConnection>>, TError,{connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHomerunConnection>>,
        TError,
        {connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoHomerunConnectionConfig},
        TContext
      > => {

      const mutationOptions = getUpdateHomerunConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetHomerunConnectionUrl = (connectionId: number,) => {


  

  return `/employer/homerun-connection/${connectionId}`
}

export const getHomerunConnection = async (connectionId: number, options?: RequestInit): Promise<GetAtsIntegrationConnectionResultHomerunConnectionConfig> => {
  
  return fetchWithAuth<GetAtsIntegrationConnectionResultHomerunConnectionConfig>(getGetHomerunConnectionUrl(connectionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetHomerunConnectionQueryKey = (connectionId?: MaybeRef<number>,) => {
    return [
    'employer','homerun-connection',connectionId
    ] as const;
    }

    
export const getGetHomerunConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getHomerunConnection>>, TError = unknown>(connectionId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomerunConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetHomerunConnectionQueryKey(connectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomerunConnection>>> = ({ signal }) => getHomerunConnection(unref(connectionId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(connectionId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHomerunConnection>>, TError, TData> 
}

export type GetHomerunConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getHomerunConnection>>>
export type GetHomerunConnectionQueryError = unknown



export function useGetHomerunConnection<TData = Awaited<ReturnType<typeof getHomerunConnection>>, TError = unknown>(
 connectionId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomerunConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHomerunConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getDeleteIntegrationConnectionUrl = (connectionId: number,) => {


  

  return `/employer/integration-connection/${connectionId}`
}

export const deleteIntegrationConnection = async (connectionId: number, options?: RequestInit): Promise<Unit> => {
  
  return fetchWithAuth<Unit>(getDeleteIntegrationConnectionUrl(connectionId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteIntegrationConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationConnection>>, TError,{connectionId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationConnection>>, TError,{connectionId: number}, TContext> => {

const mutationKey = ['deleteIntegrationConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationConnection>>, {connectionId: number}> = (props) => {
          const {connectionId} = props ?? {};

          return  deleteIntegrationConnection(connectionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationConnection>>>
    
    export type DeleteIntegrationConnectionMutationError = unknown

    export const useDeleteIntegrationConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationConnection>>, TError,{connectionId: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteIntegrationConnection>>,
        TError,
        {connectionId: number},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getListAtsJobsUrl = (connectionId: number,) => {


  

  return `/employer/integration-connection/ats-jobs/${connectionId}`
}

export const listAtsJobs = async (connectionId: number, options?: RequestInit): Promise<ListAtsJobsResult> => {
  
  return fetchWithAuth<ListAtsJobsResult>(getListAtsJobsUrl(connectionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListAtsJobsQueryKey = (connectionId?: MaybeRef<number>,) => {
    return [
    'employer','integration-connection','ats-jobs',connectionId
    ] as const;
    }

    
export const getListAtsJobsQueryOptions = <TData = Awaited<ReturnType<typeof listAtsJobs>>, TError = unknown>(connectionId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListAtsJobsQueryKey(connectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAtsJobs>>> = ({ signal }) => listAtsJobs(unref(connectionId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(connectionId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAtsJobs>>, TError, TData> 
}

export type ListAtsJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listAtsJobs>>>
export type ListAtsJobsQueryError = unknown



export function useListAtsJobs<TData = Awaited<ReturnType<typeof listAtsJobs>>, TError = unknown>(
 connectionId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAtsJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAtsJobsQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getMapJobWithAtsJobUrl = (connectionId: number,) => {


  

  return `/employer/integration-connection/ats-jobs/${connectionId}`
}

export const mapJobWithAtsJob = async (connectionId: number,
    mapJobWithAtsJobCommandDto: MapJobWithAtsJobCommandDto, options?: RequestInit): Promise<Unit> => {
  
  return fetchWithAuth<Unit>(getMapJobWithAtsJobUrl(connectionId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mapJobWithAtsJobCommandDto,)
  }
);}




export const getMapJobWithAtsJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapJobWithAtsJob>>, TError,{connectionId: number;data: MapJobWithAtsJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof mapJobWithAtsJob>>, TError,{connectionId: number;data: MapJobWithAtsJobCommandDto}, TContext> => {

const mutationKey = ['mapJobWithAtsJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapJobWithAtsJob>>, {connectionId: number;data: MapJobWithAtsJobCommandDto}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  mapJobWithAtsJob(connectionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MapJobWithAtsJobMutationResult = NonNullable<Awaited<ReturnType<typeof mapJobWithAtsJob>>>
    export type MapJobWithAtsJobMutationBody = MapJobWithAtsJobCommandDto
    export type MapJobWithAtsJobMutationError = unknown

    export const useMapJobWithAtsJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapJobWithAtsJob>>, TError,{connectionId: number;data: MapJobWithAtsJobCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof mapJobWithAtsJob>>,
        TError,
        {connectionId: number;data: MapJobWithAtsJobCommandDto},
        TContext
      > => {

      const mutationOptions = getMapJobWithAtsJobMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getConnectRecruiteeIntegrationUrl = () => {


  

  return `/employer/recruitee-connection`
}

export const connectRecruiteeIntegration = async (getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets, options?: RequestInit): Promise<IntegrationConnectionDto> => {
  
  return fetchWithAuth<IntegrationConnectionDto>(getConnectRecruiteeIntegrationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      getOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets,)
  }
);}




export const getConnectRecruiteeIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, TError,{data: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, TError,{data: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets}, TContext> => {

const mutationKey = ['connectRecruiteeIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, {data: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets}> = (props) => {
          const {data} = props ?? {};

          return  connectRecruiteeIntegration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConnectRecruiteeIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof connectRecruiteeIntegration>>>
    export type ConnectRecruiteeIntegrationMutationBody = GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets
    export type ConnectRecruiteeIntegrationMutationError = unknown

    export const useConnectRecruiteeIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectRecruiteeIntegration>>, TError,{data: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof connectRecruiteeIntegration>>,
        TError,
        {data: GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets},
        TContext
      > => {

      const mutationOptions = getConnectRecruiteeIntegrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getUpdateRecruiteeConnectionUrl = (connectionId: number,) => {


  

  return `/employer/recruitee-connection/recruitee/${connectionId}`
}

export const updateRecruiteeConnection = async (connectionId: number,
    updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig, options?: RequestInit): Promise<Unit> => {
  
  return fetchWithAuth<Unit>(getUpdateRecruiteeConnectionUrl(connectionId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig,)
  }
);}




export const getUpdateRecruiteeConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruiteeConnection>>, TError,{connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRecruiteeConnection>>, TError,{connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig}, TContext> => {

const mutationKey = ['updateRecruiteeConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRecruiteeConnection>>, {connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateRecruiteeConnection(connectionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRecruiteeConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateRecruiteeConnection>>>
    export type UpdateRecruiteeConnectionMutationBody = UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig
    export type UpdateRecruiteeConnectionMutationError = unknown

    export const useUpdateRecruiteeConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRecruiteeConnection>>, TError,{connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateRecruiteeConnection>>,
        TError,
        {connectionId: number;data: UpdateAtsIntegrationConnectionCommandDtoRecruiteeConnectionConfig},
        TContext
      > => {

      const mutationOptions = getUpdateRecruiteeConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetRecruiteeConnectionUrl = (connectionId: number,) => {


  

  return `/employer/recruitee-connection/recruitee/${connectionId}`
}

export const getRecruiteeConnection = async (connectionId: number, options?: RequestInit): Promise<GetAtsIntegrationConnectionResultRecruiteeConnectionConfig> => {
  
  return fetchWithAuth<GetAtsIntegrationConnectionResultRecruiteeConnectionConfig>(getGetRecruiteeConnectionUrl(connectionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetRecruiteeConnectionQueryKey = (connectionId?: MaybeRef<number>,) => {
    return [
    'employer','recruitee-connection','recruitee',connectionId
    ] as const;
    }

    
export const getGetRecruiteeConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getRecruiteeConnection>>, TError = unknown>(connectionId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetRecruiteeConnectionQueryKey(connectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecruiteeConnection>>> = ({ signal }) => getRecruiteeConnection(unref(connectionId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(connectionId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeConnection>>, TError, TData> 
}

export type GetRecruiteeConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getRecruiteeConnection>>>
export type GetRecruiteeConnectionQueryError = unknown



export function useGetRecruiteeConnection<TData = Awaited<ReturnType<typeof getRecruiteeConnection>>, TError = unknown>(
 connectionId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecruiteeConnection>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRecruiteeConnectionQueryOptions(connectionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getCreateEmployerInviteUrl = () => {


  

  return `/admin/employer/create-employer-invite/employer`
}

export const createEmployerInvite = async (createEmployerInviteCommandDto: CreateEmployerInviteCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getCreateEmployerInviteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEmployerInviteCommandDto,)
  }
);}




export const getCreateEmployerInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployerInvite>>, TError,{data: CreateEmployerInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployerInvite>>, TError,{data: CreateEmployerInviteCommandDto}, TContext> => {

const mutationKey = ['createEmployerInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployerInvite>>, {data: CreateEmployerInviteCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createEmployerInvite(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployerInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployerInvite>>>
    export type CreateEmployerInviteMutationBody = CreateEmployerInviteCommandDto
    export type CreateEmployerInviteMutationError = unknown

    export const useCreateEmployerInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployerInvite>>, TError,{data: CreateEmployerInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createEmployerInvite>>,
        TError,
        {data: CreateEmployerInviteCommandDto},
        TContext
      > => {

      const mutationOptions = getCreateEmployerInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getCreateTeammateInviteUrl = () => {


  

  return `/admin/employer/create-teammate-invite/teammate`
}

export const createTeammateInvite = async (createTeammateInviteCommandDto: CreateTeammateInviteCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getCreateTeammateInviteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTeammateInviteCommandDto,)
  }
);}




export const getCreateTeammateInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeammateInvite>>, TError,{data: CreateTeammateInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeammateInvite>>, TError,{data: CreateTeammateInviteCommandDto}, TContext> => {

const mutationKey = ['createTeammateInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeammateInvite>>, {data: CreateTeammateInviteCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createTeammateInvite(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTeammateInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createTeammateInvite>>>
    export type CreateTeammateInviteMutationBody = CreateTeammateInviteCommandDto
    export type CreateTeammateInviteMutationError = unknown

    export const useCreateTeammateInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeammateInvite>>, TError,{data: CreateTeammateInviteCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTeammateInvite>>,
        TError,
        {data: CreateTeammateInviteCommandDto},
        TContext
      > => {

      const mutationOptions = getCreateTeammateInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getListReferralInvitesUrl = () => {


  

  return `/admin/employer/list-referral-invites`
}

export const listReferralInvites = async ( options?: RequestInit): Promise<ListReferralInvitesResult> => {
  
  return fetchWithAuth<ListReferralInvitesResult>(getListReferralInvitesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListReferralInvitesQueryKey = () => {
    return [
    'admin','employer','list-referral-invites'
    ] as const;
    }

    
export const getListReferralInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listReferralInvites>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReferralInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListReferralInvitesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReferralInvites>>> = ({ signal }) => listReferralInvites({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReferralInvites>>, TError, TData> 
}

export type ListReferralInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listReferralInvites>>>
export type ListReferralInvitesQueryError = unknown



export function useListReferralInvites<TData = Awaited<ReturnType<typeof listReferralInvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReferralInvites>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReferralInvitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getDeleteTeammateUrl = () => {


  

  return `/admin/employer/delete-teammate/teammate`
}

export const deleteTeammate = async (deleteEmployerCommandDto: DeleteEmployerCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getDeleteTeammateUrl(),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteEmployerCommandDto,)
  }
);}




export const getDeleteTeammateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeammate>>, TError,{data: DeleteEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeammate>>, TError,{data: DeleteEmployerCommandDto}, TContext> => {

const mutationKey = ['deleteTeammate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeammate>>, {data: DeleteEmployerCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  deleteTeammate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeammateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeammate>>>
    export type DeleteTeammateMutationBody = DeleteEmployerCommandDto
    export type DeleteTeammateMutationError = unknown

    export const useDeleteTeammate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeammate>>, TError,{data: DeleteEmployerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTeammate>>,
        TError,
        {data: DeleteEmployerCommandDto},
        TContext
      > => {

      const mutationOptions = getDeleteTeammateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetEmployerAccessUrl = () => {


  

  return `/employer/profile/access`
}

export const getEmployerAccess = async ( options?: RequestInit): Promise<GetEmployerAccessResult> => {
  
  return fetchWithAuth<GetEmployerAccessResult>(getGetEmployerAccessUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployerAccessQueryKey = () => {
    return [
    'employer','profile','access'
    ] as const;
    }

    
export const getGetEmployerAccessQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerAccess>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerAccess>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetEmployerAccessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerAccess>>> = ({ signal }) => getEmployerAccess({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerAccess>>, TError, TData> 
}

export type GetEmployerAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerAccess>>>
export type GetEmployerAccessQueryError = unknown



export function useGetEmployerAccess<TData = Awaited<ReturnType<typeof getEmployerAccess>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployerAccess>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployerAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetProfileUrl = () => {


  

  return `/employer/profile`
}

export const getProfile = async ( options?: RequestInit): Promise<GetEmployerProfileResult> => {
  
  return fetchWithAuth<GetEmployerProfileResult>(getGetProfileUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetProfileQueryKey = () => {
    return [
    'employer','profile'
    ] as const;
    }

    
export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> 
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = unknown



export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getUpdateProfileUrl = () => {


  

  return `/employer/profile`
}

export const updateProfile = async (updateEmployerProfileCommandDto: UpdateEmployerProfileCommandDto, options?: RequestInit): Promise<number> => {
  
  return fetchWithAuth<number>(getUpdateProfileUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateEmployerProfileCommandDto,)
  }
);}




export const getUpdateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UpdateEmployerProfileCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UpdateEmployerProfileCommandDto}, TContext> => {

const mutationKey = ['updateProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {data: UpdateEmployerProfileCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = UpdateEmployerProfileCommandDto
    export type UpdateProfileMutationError = unknown

    export const useUpdateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UpdateEmployerProfileCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {data: UpdateEmployerProfileCommandDto},
        TContext
      > => {

      const mutationOptions = getUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetStatisticsUrl = () => {


  

  return `/employer/dashboard/statistics`
}

export const getStatistics = async ( options?: RequestInit): Promise<GetCompanyStatisticsResult> => {
  
  return fetchWithAuth<GetCompanyStatisticsResult>(getGetStatisticsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetStatisticsQueryKey = () => {
    return [
    'employer','dashboard','statistics'
    ] as const;
    }

    
export const getGetStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getStatistics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatistics>>> = ({ signal }) => getStatistics({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData> 
}

export type GetStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getStatistics>>>
export type GetStatisticsQueryError = unknown



export function useGetStatistics<TData = Awaited<ReturnType<typeof getStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatisticsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListUnhandledJobsUrl = (params?: ListUnhandledJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/dashboard/unhandled-jobs?${stringifiedParams}` : `/employer/dashboard/unhandled-jobs`
}

export const listUnhandledJobs = async (params?: ListUnhandledJobsParams, options?: RequestInit): Promise<ListUnhandledJobsResult> => {
  
  return fetchWithAuth<ListUnhandledJobsResult>(getListUnhandledJobsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListUnhandledJobsQueryKey = (params?: MaybeRef<ListUnhandledJobsParams>,) => {
    return [
    'employer','dashboard','unhandled-jobs', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListUnhandledJobsQueryOptions = <TData = Awaited<ReturnType<typeof listUnhandledJobs>>, TError = unknown>(params?: MaybeRef<ListUnhandledJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnhandledJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListUnhandledJobsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnhandledJobs>>> = ({ signal }) => listUnhandledJobs(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnhandledJobs>>, TError, TData> 
}

export type ListUnhandledJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listUnhandledJobs>>>
export type ListUnhandledJobsQueryError = unknown



export function useListUnhandledJobs<TData = Awaited<ReturnType<typeof listUnhandledJobs>>, TError = unknown>(
 params?: MaybeRef<ListUnhandledJobsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnhandledJobs>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUnhandledJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all unhandled matches for the current company
 */
export const getListUnhandledMatchesUrl = (params?: ListUnhandledMatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/dashboard/unhandled-matches?${stringifiedParams}` : `/employer/dashboard/unhandled-matches`
}

export const listUnhandledMatches = async (params?: ListUnhandledMatchesParams, options?: RequestInit): Promise<ListUnhandledMatchesResult> => {
  
  return fetchWithAuth<ListUnhandledMatchesResult>(getListUnhandledMatchesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListUnhandledMatchesQueryKey = (params?: MaybeRef<ListUnhandledMatchesParams>,) => {
    return [
    'employer','dashboard','unhandled-matches', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListUnhandledMatchesQueryOptions = <TData = Awaited<ReturnType<typeof listUnhandledMatches>>, TError = unknown>(params?: MaybeRef<ListUnhandledMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnhandledMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListUnhandledMatchesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnhandledMatches>>> = ({ signal }) => listUnhandledMatches(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnhandledMatches>>, TError, TData> 
}

export type ListUnhandledMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listUnhandledMatches>>>
export type ListUnhandledMatchesQueryError = unknown


/**
 * @summary List all unhandled matches for the current company
 */

export function useListUnhandledMatches<TData = Awaited<ReturnType<typeof listUnhandledMatches>>, TError = unknown>(
 params?: MaybeRef<ListUnhandledMatchesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnhandledMatches>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUnhandledMatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetConferenceInfoUrl = () => {


  

  return `/employer/conference`
}

export const getConferenceInfo = async ( options?: RequestInit): Promise<GetConferenceInfoResult> => {
  
  return fetchWithAuth<GetConferenceInfoResult>(getGetConferenceInfoUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetConferenceInfoQueryKey = () => {
    return [
    'employer','conference'
    ] as const;
    }

    
export const getGetConferenceInfoQueryOptions = <TData = Awaited<ReturnType<typeof getConferenceInfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetConferenceInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConferenceInfo>>> = ({ signal }) => getConferenceInfo({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConferenceInfo>>, TError, TData> 
}

export type GetConferenceInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getConferenceInfo>>>
export type GetConferenceInfoQueryError = unknown



export function useGetConferenceInfo<TData = Awaited<ReturnType<typeof getConferenceInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConferenceInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListConferenceChatsEmployerUrl = (params: ListConferenceChatsEmployerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/conference/chat?${stringifiedParams}` : `/employer/conference/chat`
}

export const listConferenceChatsEmployer = async (params: ListConferenceChatsEmployerParams, options?: RequestInit): Promise<ListConferenceChatsResult> => {
  
  return fetchWithAuth<ListConferenceChatsResult>(getListConferenceChatsEmployerUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListConferenceChatsEmployerQueryKey = (params?: MaybeRef<ListConferenceChatsEmployerParams>,) => {
    return [
    'employer','conference','chat', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListConferenceChatsEmployerQueryOptions = <TData = Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError = unknown>(params: MaybeRef<ListConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListConferenceChatsEmployerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConferenceChatsEmployer>>> = ({ signal }) => listConferenceChatsEmployer(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError, TData> 
}

export type ListConferenceChatsEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof listConferenceChatsEmployer>>>
export type ListConferenceChatsEmployerQueryError = unknown



export function useListConferenceChatsEmployer<TData = Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError = unknown>(
 params: MaybeRef<ListConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConferenceChatsEmployerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getSendConferenceChatMessageEmployerUrl = () => {


  

  return `/employer/conference/chat`
}

export const sendConferenceChatMessageEmployer = async (sendMessageCommandDto: SendMessageCommandDto, options?: RequestInit): Promise<ChatMessageDto> => {
  
  return fetchWithAuth<ChatMessageDto>(getSendConferenceChatMessageEmployerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendMessageCommandDto,)
  }
);}




export const getSendConferenceChatMessageEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, TError,{data: SendMessageCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, TError,{data: SendMessageCommandDto}, TContext> => {

const mutationKey = ['sendConferenceChatMessageEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, {data: SendMessageCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  sendConferenceChatMessageEmployer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendConferenceChatMessageEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>>
    export type SendConferenceChatMessageEmployerMutationBody = SendMessageCommandDto
    export type SendConferenceChatMessageEmployerMutationError = unknown

    export const useSendConferenceChatMessageEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>, TError,{data: SendMessageCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendConferenceChatMessageEmployer>>,
        TError,
        {data: SendMessageCommandDto},
        TContext
      > => {

      const mutationOptions = getSendConferenceChatMessageEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getListUnreadConferenceChatsEmployerUrl = (params: ListUnreadConferenceChatsEmployerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/employer/conference/chat-unread?${stringifiedParams}` : `/employer/conference/chat-unread`
}

export const listUnreadConferenceChatsEmployer = async (params: ListUnreadConferenceChatsEmployerParams, options?: RequestInit): Promise<ListUnreadConferenceChatsResult> => {
  
  return fetchWithAuth<ListUnreadConferenceChatsResult>(getListUnreadConferenceChatsEmployerUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListUnreadConferenceChatsEmployerQueryKey = (params?: MaybeRef<ListUnreadConferenceChatsEmployerParams>,) => {
    return [
    'employer','conference','chat-unread', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListUnreadConferenceChatsEmployerQueryOptions = <TData = Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError = unknown>(params: MaybeRef<ListUnreadConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListUnreadConferenceChatsEmployerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>> = ({ signal }) => listUnreadConferenceChatsEmployer(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError, TData> 
}

export type ListUnreadConferenceChatsEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>>
export type ListUnreadConferenceChatsEmployerQueryError = unknown



export function useListUnreadConferenceChatsEmployer<TData = Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError = unknown>(
 params: MaybeRef<ListUnreadConferenceChatsEmployerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUnreadConferenceChatsEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUnreadConferenceChatsEmployerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetConferenceChatWithMessagesForEmployerUrl = (chatId: number,) => {


  

  return `/employer/conference/chat/${chatId}`
}

export const getConferenceChatWithMessagesForEmployer = async (chatId: number, options?: RequestInit): Promise<GetConferenceChatWithMessagesForEmployerResult> => {
  
  return fetchWithAuth<GetConferenceChatWithMessagesForEmployerResult>(getGetConferenceChatWithMessagesForEmployerUrl(chatId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetConferenceChatWithMessagesForEmployerQueryKey = (chatId?: MaybeRef<number>,) => {
    return [
    'employer','conference','chat',chatId
    ] as const;
    }

    
export const getGetConferenceChatWithMessagesForEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError = unknown>(chatId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetConferenceChatWithMessagesForEmployerQueryKey(chatId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>> = ({ signal }) => getConferenceChatWithMessagesForEmployer(unref(chatId), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(chatId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError, TData> 
}

export type GetConferenceChatWithMessagesForEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>>
export type GetConferenceChatWithMessagesForEmployerQueryError = unknown



export function useGetConferenceChatWithMessagesForEmployer<TData = Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError = unknown>(
 chatId: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConferenceChatWithMessagesForEmployer>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConferenceChatWithMessagesForEmployerQueryOptions(chatId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetMyCompanyUrl = () => {


  

  return `/employer/company`
}

export const getMyCompany = async ( options?: RequestInit): Promise<GetCompanyFromPortalResult> => {
  
  return fetchWithAuth<GetCompanyFromPortalResult>(getGetMyCompanyUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMyCompanyQueryKey = () => {
    return [
    'employer','company'
    ] as const;
    }

    
export const getGetMyCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getMyCompany>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMyCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCompany>>> = ({ signal }) => getMyCompany({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCompany>>, TError, TData> 
}

export type GetMyCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCompany>>>
export type GetMyCompanyQueryError = unknown



export function useGetMyCompany<TData = Awaited<ReturnType<typeof getMyCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getUpdateMyCompanyUrl = () => {


  

  return `/employer/company`
}

export const updateMyCompany = async (updateCompanyFromPortalCommandDto: UpdateCompanyFromPortalCommandDto, options?: RequestInit): Promise<number> => {
  
  return fetchWithAuth<number>(getUpdateMyCompanyUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCompanyFromPortalCommandDto,)
  }
);}




export const getUpdateMyCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyCompany>>, TError,{data: UpdateCompanyFromPortalCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyCompany>>, TError,{data: UpdateCompanyFromPortalCommandDto}, TContext> => {

const mutationKey = ['updateMyCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyCompany>>, {data: UpdateCompanyFromPortalCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  updateMyCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyCompany>>>
    export type UpdateMyCompanyMutationBody = UpdateCompanyFromPortalCommandDto
    export type UpdateMyCompanyMutationError = unknown

    export const useUpdateMyCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyCompany>>, TError,{data: UpdateCompanyFromPortalCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateMyCompany>>,
        TError,
        {data: UpdateCompanyFromPortalCommandDto},
        TContext
      > => {

      const mutationOptions = getUpdateMyCompanyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete a Company.
This will close all related matches, jobs and other data.
 */
export const getDeleteMyCompanyUrl = () => {


  

  return `/employer/company`
}

export const deleteMyCompany = async ( options?: RequestInit): Promise<number> => {
  
  return fetchWithAuth<number>(getDeleteMyCompanyUrl(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteMyCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMyCompany>>, TError,void, TContext> => {

const mutationKey = ['deleteMyCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMyCompany>>, void> = () => {
          

          return  deleteMyCompany(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMyCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMyCompany>>>
    
    export type DeleteMyCompanyMutationError = unknown

    /**
 * @summary Delete a Company.
This will close all related matches, jobs and other data.
 */
export const useDeleteMyCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteMyCompany>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteMyCompanyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetMyCompanyPlanUrl = () => {


  

  return `/employer/company/plan`
}

export const getMyCompanyPlan = async ( options?: RequestInit): Promise<GetCompanyPlanResult> => {
  
  return fetchWithAuth<GetCompanyPlanResult>(getGetMyCompanyPlanUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMyCompanyPlanQueryKey = () => {
    return [
    'employer','company','plan'
    ] as const;
    }

    
export const getGetMyCompanyPlanQueryOptions = <TData = Awaited<ReturnType<typeof getMyCompanyPlan>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompanyPlan>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMyCompanyPlanQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCompanyPlan>>> = ({ signal }) => getMyCompanyPlan({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCompanyPlan>>, TError, TData> 
}

export type GetMyCompanyPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCompanyPlan>>>
export type GetMyCompanyPlanQueryError = unknown



export function useGetMyCompanyPlan<TData = Awaited<ReturnType<typeof getMyCompanyPlan>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCompanyPlan>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyCompanyPlanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListEmployersForCompanyUrl = () => {


  

  return `/employer/company/employers`
}

export const listEmployersForCompany = async ( options?: RequestInit): Promise<ListOtherEmployersForCompanyResult> => {
  
  return fetchWithAuth<ListOtherEmployersForCompanyResult>(getListEmployersForCompanyUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListEmployersForCompanyQueryKey = () => {
    return [
    'employer','company','employers'
    ] as const;
    }

    
export const getListEmployersForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof listEmployersForCompany>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployersForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListEmployersForCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployersForCompany>>> = ({ signal }) => listEmployersForCompany({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployersForCompany>>, TError, TData> 
}

export type ListEmployersForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployersForCompany>>>
export type ListEmployersForCompanyQueryError = unknown



export function useListEmployersForCompany<TData = Awaited<ReturnType<typeof listEmployersForCompany>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployersForCompany>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmployersForCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getAddOrUpdateDefaultMessageUrl = () => {


  

  return `/employer/company/default-messages`
}

export const addOrUpdateDefaultMessage = async (addOrUpdateDefaultMessageCommandDto: AddOrUpdateDefaultMessageCommandDto, options?: RequestInit): Promise<AddOrUpdateDefaultMessageResult> => {
  
  return fetchWithAuth<AddOrUpdateDefaultMessageResult>(getAddOrUpdateDefaultMessageUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addOrUpdateDefaultMessageCommandDto,)
  }
);}




export const getAddOrUpdateDefaultMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, TError,{data: AddOrUpdateDefaultMessageCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, TError,{data: AddOrUpdateDefaultMessageCommandDto}, TContext> => {

const mutationKey = ['addOrUpdateDefaultMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, {data: AddOrUpdateDefaultMessageCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  addOrUpdateDefaultMessage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddOrUpdateDefaultMessageMutationResult = NonNullable<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>>
    export type AddOrUpdateDefaultMessageMutationBody = AddOrUpdateDefaultMessageCommandDto
    export type AddOrUpdateDefaultMessageMutationError = unknown

    export const useAddOrUpdateDefaultMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>, TError,{data: AddOrUpdateDefaultMessageCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addOrUpdateDefaultMessage>>,
        TError,
        {data: AddOrUpdateDefaultMessageCommandDto},
        TContext
      > => {

      const mutationOptions = getAddOrUpdateDefaultMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getDeleteDefaultMessageUrl = (id: number,) => {


  

  return `/employer/company/default-messages/${id}`
}

export const deleteDefaultMessage = async (id: number, options?: RequestInit): Promise<DeleteDefaultMessageResult> => {
  
  return fetchWithAuth<DeleteDefaultMessageResult>(getDeleteDefaultMessageUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteDefaultMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDefaultMessage>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDefaultMessage>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDefaultMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDefaultMessage>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDefaultMessage(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDefaultMessageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDefaultMessage>>>
    
    export type DeleteDefaultMessageMutationError = unknown

    export const useDeleteDefaultMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDefaultMessage>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteDefaultMessage>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteDefaultMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Upload Provisional Company Image
 */
export const getUploadProvisionalImageUrl = () => {


  

  return `/employer/company/provisional-image`
}

export const uploadProvisionalImage = async (uploadProvisionalImageBody: UploadProvisionalImageBody, options?: RequestInit): Promise<ImageDto> => {
    const formData = new FormData();
if(uploadProvisionalImageBody.File !== undefined) {
 formData.append(`File`, uploadProvisionalImageBody.File)
 }

  return fetchWithAuth<ImageDto>(getUploadProvisionalImageUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getUploadProvisionalImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadProvisionalImage>>, TError,{data: UploadProvisionalImageBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadProvisionalImage>>, TError,{data: UploadProvisionalImageBody}, TContext> => {

const mutationKey = ['uploadProvisionalImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadProvisionalImage>>, {data: UploadProvisionalImageBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadProvisionalImage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadProvisionalImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadProvisionalImage>>>
    export type UploadProvisionalImageMutationBody = UploadProvisionalImageBody
    export type UploadProvisionalImageMutationError = unknown

    /**
 * @summary Upload Provisional Company Image
 */
export const useUploadProvisionalImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadProvisionalImage>>, TError,{data: UploadProvisionalImageBody}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadProvisionalImage>>,
        TError,
        {data: UploadProvisionalImageBody},
        TContext
      > => {

      const mutationOptions = getUploadProvisionalImageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSendRequestToAccountManagerUrl = () => {


  

  return `/employer/company/send-account-manager-request`
}

export const sendRequestToAccountManager = async (sendRequestToAccountManagerCommandDto: SendRequestToAccountManagerCommandDto, options?: RequestInit): Promise<Unit> => {
  
  return fetchWithAuth<Unit>(getSendRequestToAccountManagerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendRequestToAccountManagerCommandDto,)
  }
);}




export const getSendRequestToAccountManagerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRequestToAccountManager>>, TError,{data: SendRequestToAccountManagerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof sendRequestToAccountManager>>, TError,{data: SendRequestToAccountManagerCommandDto}, TContext> => {

const mutationKey = ['sendRequestToAccountManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRequestToAccountManager>>, {data: SendRequestToAccountManagerCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  sendRequestToAccountManager(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendRequestToAccountManagerMutationResult = NonNullable<Awaited<ReturnType<typeof sendRequestToAccountManager>>>
    export type SendRequestToAccountManagerMutationBody = SendRequestToAccountManagerCommandDto
    export type SendRequestToAccountManagerMutationError = unknown

    export const useSendRequestToAccountManager = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRequestToAccountManager>>, TError,{data: SendRequestToAccountManagerCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendRequestToAccountManager>>,
        TError,
        {data: SendRequestToAccountManagerCommandDto},
        TContext
      > => {

      const mutationOptions = getSendRequestToAccountManagerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetCompanyHireReportInfoUrl = () => {


  

  return `/employer/hire-report`
}

export const getCompanyHireReportInfo = async ( options?: RequestInit): Promise<GetCompanyHireReportInfoResult> => {
  
  return fetchWithAuth<GetCompanyHireReportInfoResult>(getGetCompanyHireReportInfoUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetCompanyHireReportInfoQueryKey = () => {
    return [
    'employer','hire-report'
    ] as const;
    }

    
export const getGetCompanyHireReportInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetCompanyHireReportInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyHireReportInfo>>> = ({ signal }) => getCompanyHireReportInfo({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError, TData> 
}

export type GetCompanyHireReportInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyHireReportInfo>>>
export type GetCompanyHireReportInfoQueryError = unknown



export function useGetCompanyHireReportInfo<TData = Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyHireReportInfo>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyHireReportInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getCreateCompanyHireReportUrl = () => {


  

  return `/employer/hire-report`
}

export const createCompanyHireReport = async (createCompanyHireReportCommandDto: CreateCompanyHireReportCommandDto, options?: RequestInit): Promise<CreateCompanyHireReport> => {
  
  return fetchWithAuth<CreateCompanyHireReport>(getCreateCompanyHireReportUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCompanyHireReportCommandDto,)
  }
);}




export const getCreateCompanyHireReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyHireReport>>, TError,{data: CreateCompanyHireReportCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyHireReport>>, TError,{data: CreateCompanyHireReportCommandDto}, TContext> => {

const mutationKey = ['createCompanyHireReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyHireReport>>, {data: CreateCompanyHireReportCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyHireReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyHireReportMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyHireReport>>>
    export type CreateCompanyHireReportMutationBody = CreateCompanyHireReportCommandDto
    export type CreateCompanyHireReportMutationError = unknown

    export const useCreateCompanyHireReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyHireReport>>, TError,{data: CreateCompanyHireReportCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCompanyHireReport>>,
        TError,
        {data: CreateCompanyHireReportCommandDto},
        TContext
      > => {

      const mutationOptions = getCreateCompanyHireReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSetMatchingConfigurationUrl = () => {


  

  return `/employer/company-matching-configuration`
}

export const setMatchingConfiguration = async (setCompanyMatchingConfigurationCommandDto: SetCompanyMatchingConfigurationCommandDto, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getSetMatchingConfigurationUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setCompanyMatchingConfigurationCommandDto,)
  }
);}




export const getSetMatchingConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMatchingConfiguration>>, TError,{data: SetCompanyMatchingConfigurationCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof setMatchingConfiguration>>, TError,{data: SetCompanyMatchingConfigurationCommandDto}, TContext> => {

const mutationKey = ['setMatchingConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMatchingConfiguration>>, {data: SetCompanyMatchingConfigurationCommandDto}> = (props) => {
          const {data} = props ?? {};

          return  setMatchingConfiguration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetMatchingConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof setMatchingConfiguration>>>
    export type SetMatchingConfigurationMutationBody = SetCompanyMatchingConfigurationCommandDto
    export type SetMatchingConfigurationMutationError = unknown

    export const useSetMatchingConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMatchingConfiguration>>, TError,{data: SetCompanyMatchingConfigurationCommandDto}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setMatchingConfiguration>>,
        TError,
        {data: SetCompanyMatchingConfigurationCommandDto},
        TContext
      > => {

      const mutationOptions = getSetMatchingConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getResetMatchingConfigurationUrl = () => {


  

  return `/employer/company-matching-configuration`
}

export const resetMatchingConfiguration = async ( options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getResetMatchingConfigurationUrl(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getResetMatchingConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMatchingConfiguration>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resetMatchingConfiguration>>, TError,void, TContext> => {

const mutationKey = ['resetMatchingConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetMatchingConfiguration>>, void> = () => {
          

          return  resetMatchingConfiguration(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetMatchingConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof resetMatchingConfiguration>>>
    
    export type ResetMatchingConfigurationMutationError = unknown

    export const useResetMatchingConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetMatchingConfiguration>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetMatchingConfiguration>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getResetMatchingConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGetMatchingConfigurationUrl = () => {


  

  return `/employer/company-matching-configuration`
}

export const getMatchingConfiguration = async ( options?: RequestInit): Promise<GetCompanyMatchingConfigurationResult> => {
  
  return fetchWithAuth<GetCompanyMatchingConfigurationResult>(getGetMatchingConfigurationUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMatchingConfigurationQueryKey = () => {
    return [
    'employer','company-matching-configuration'
    ] as const;
    }

    
export const getGetMatchingConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getMatchingConfiguration>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingConfiguration>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetMatchingConfigurationQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchingConfiguration>>> = ({ signal }) => getMatchingConfiguration({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMatchingConfiguration>>, TError, TData> 
}

export type GetMatchingConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getMatchingConfiguration>>>
export type GetMatchingConfigurationQueryError = unknown



export function useGetMatchingConfiguration<TData = Awaited<ReturnType<typeof getMatchingConfiguration>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMatchingConfiguration>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMatchingConfigurationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Request a login link to be sent to the user's email via jwt token
Currently only for employers with auth provider Internal Jwt aka Lead employers
 */
export const getRequestLoginLinkUrl = () => {


  

  return `/employer/authentication/login-link`
}

export const requestLoginLink = async (requestLoginLinkBody: string, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getRequestLoginLinkUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      requestLoginLinkBody,)
  }
);}




export const getRequestLoginLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLoginLink>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof requestLoginLink>>, TError,{data: string}, TContext> => {

const mutationKey = ['requestLoginLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestLoginLink>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  requestLoginLink(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestLoginLinkMutationResult = NonNullable<Awaited<ReturnType<typeof requestLoginLink>>>
    export type RequestLoginLinkMutationBody = string
    export type RequestLoginLinkMutationError = unknown

    /**
 * @summary Request a login link to be sent to the user's email via jwt token
Currently only for employers with auth provider Internal Jwt aka Lead employers
 */
export const useRequestLoginLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLoginLink>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof requestLoginLink>>,
        TError,
        {data: string},
        TContext
      > => {

      const mutationOptions = getRequestLoginLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List the companies that an employer is allowed to manage
 */
export const getListManagedCompaniesUrl = () => {


  

  return `/employer/company-admin`
}

export const listManagedCompanies = async ( options?: RequestInit): Promise<ListManagedCompaniesResult> => {
  
  return fetchWithAuth<ListManagedCompaniesResult>(getListManagedCompaniesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListManagedCompaniesQueryKey = () => {
    return [
    'employer','company-admin'
    ] as const;
    }

    
export const getListManagedCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listManagedCompanies>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listManagedCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListManagedCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listManagedCompanies>>> = ({ signal }) => listManagedCompanies({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listManagedCompanies>>, TError, TData> 
}

export type ListManagedCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listManagedCompanies>>>
export type ListManagedCompaniesQueryError = unknown


/**
 * @summary List the companies that an employer is allowed to manage
 */

export function useListManagedCompanies<TData = Awaited<ReturnType<typeof listManagedCompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listManagedCompanies>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListManagedCompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update the company that an employer manages.
 */
export const getUpdateManagedCompanyUrl = () => {


  

  return `/employer/company-admin/update`
}

export const updateManagedCompany = async (updateManagedCompanyBody: number, options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getUpdateManagedCompanyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateManagedCompanyBody,)
  }
);}




export const getUpdateManagedCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateManagedCompany>>, TError,{data: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof updateManagedCompany>>, TError,{data: number}, TContext> => {

const mutationKey = ['updateManagedCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateManagedCompany>>, {data: number}> = (props) => {
          const {data} = props ?? {};

          return  updateManagedCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateManagedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateManagedCompany>>>
    export type UpdateManagedCompanyMutationBody = number
    export type UpdateManagedCompanyMutationError = unknown

    /**
 * @summary Update the company that an employer manages.
 */
export const useUpdateManagedCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateManagedCompany>>, TError,{data: number}, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateManagedCompany>>,
        TError,
        {data: number},
        TContext
      > => {

      const mutationOptions = getUpdateManagedCompanyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Reset the company of an employer.
 */
export const getResetManagedCompanyUrl = () => {


  

  return `/employer/company-admin/reset`
}

export const resetManagedCompany = async ( options?: RequestInit): Promise<void> => {
  
  return fetchWithAuth<void>(getResetManagedCompanyUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getResetManagedCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetManagedCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
): UseMutationOptions<Awaited<ReturnType<typeof resetManagedCompany>>, TError,void, TContext> => {

const mutationKey = ['resetManagedCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetManagedCompany>>, void> = () => {
          

          return  resetManagedCompany(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetManagedCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof resetManagedCompany>>>
    
    export type ResetManagedCompanyMutationError = unknown

    /**
 * @summary Reset the company of an employer.
 */
export const useResetManagedCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetManagedCompany>>, TError,void, TContext>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resetManagedCompany>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getResetManagedCompanyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List all education levels
 */
export const getListEducationLevelsUrl = () => {


  

  return `/education-level`
}

export const listEducationLevels = async ( options?: RequestInit): Promise<ListEducationLevelsResult> => {
  
  return fetchWithAuth<ListEducationLevelsResult>(getListEducationLevelsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListEducationLevelsQueryKey = () => {
    return [
    'education-level'
    ] as const;
    }

    
export const getListEducationLevelsQueryOptions = <TData = Awaited<ReturnType<typeof listEducationLevels>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListEducationLevelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEducationLevels>>> = ({ signal }) => listEducationLevels({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData> 
}

export type ListEducationLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof listEducationLevels>>>
export type ListEducationLevelsQueryError = unknown


/**
 * @summary List all education levels
 */

export function useListEducationLevels<TData = Awaited<ReturnType<typeof listEducationLevels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEducationLevels>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEducationLevelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all personal characteristics
 */
export const getListPersonalCharacteristicsUrl = () => {


  

  return `/personal-characteristics`
}

export const listPersonalCharacteristics = async ( options?: RequestInit): Promise<ListPersonalCharacteristicsResult> => {
  
  return fetchWithAuth<ListPersonalCharacteristicsResult>(getListPersonalCharacteristicsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListPersonalCharacteristicsQueryKey = () => {
    return [
    'personal-characteristics'
    ] as const;
    }

    
export const getListPersonalCharacteristicsQueryOptions = <TData = Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPersonalCharacteristicsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalCharacteristics>>> = ({ signal }) => listPersonalCharacteristics({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData> 
}

export type ListPersonalCharacteristicsQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalCharacteristics>>>
export type ListPersonalCharacteristicsQueryError = unknown


/**
 * @summary List all personal characteristics
 */

export function useListPersonalCharacteristics<TData = Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalCharacteristics>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonalCharacteristicsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all new job reasons
 */
export const getListNewJobReasonsUrl = () => {


  

  return `/new-job-reasons`
}

export const listNewJobReasons = async ( options?: RequestInit): Promise<ListNewJobReasonsResult> => {
  
  return fetchWithAuth<ListNewJobReasonsResult>(getListNewJobReasonsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListNewJobReasonsQueryKey = () => {
    return [
    'new-job-reasons'
    ] as const;
    }

    
export const getListNewJobReasonsQueryOptions = <TData = Awaited<ReturnType<typeof listNewJobReasons>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListNewJobReasonsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNewJobReasons>>> = ({ signal }) => listNewJobReasons({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData> 
}

export type ListNewJobReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof listNewJobReasons>>>
export type ListNewJobReasonsQueryError = unknown


/**
 * @summary List all new job reasons
 */

export function useListNewJobReasons<TData = Awaited<ReturnType<typeof listNewJobReasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNewJobReasons>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNewJobReasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListPersonalityTypesUrl = () => {


  

  return `/personality-types`
}

export const listPersonalityTypes = async ( options?: RequestInit): Promise<ListPersonalityTypesResult> => {
  
  return fetchWithAuth<ListPersonalityTypesResult>(getListPersonalityTypesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListPersonalityTypesQueryKey = () => {
    return [
    'personality-types'
    ] as const;
    }

    
export const getListPersonalityTypesQueryOptions = <TData = Awaited<ReturnType<typeof listPersonalityTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListPersonalityTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalityTypes>>> = ({ signal }) => listPersonalityTypes({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData> 
}

export type ListPersonalityTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalityTypes>>>
export type ListPersonalityTypesQueryError = unknown



export function useListPersonalityTypes<TData = Awaited<ReturnType<typeof listPersonalityTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonalityTypes>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonalityTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Get Auto complete locations from the Google Places API.
 */
export const getGetAutoCompleteLocationsUrl = (params: GetAutoCompleteLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/auto-complete?${stringifiedParams}` : `/location/auto-complete`
}

export const getAutoCompleteLocations = async (params: GetAutoCompleteLocationsParams, options?: RequestInit): Promise<GetAutoCompleteLocationsResult> => {
  
  return fetchWithAuth<GetAutoCompleteLocationsResult>(getGetAutoCompleteLocationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAutoCompleteLocationsQueryKey = (params?: MaybeRef<GetAutoCompleteLocationsParams>,) => {
    return [
    'location','auto-complete', ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAutoCompleteLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError = unknown>(params: MaybeRef<GetAutoCompleteLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetAutoCompleteLocationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutoCompleteLocations>>> = ({ signal }) => getAutoCompleteLocations(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData> 
}

export type GetAutoCompleteLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAutoCompleteLocations>>>
export type GetAutoCompleteLocationsQueryError = unknown


/**
 * @summary Get Auto complete locations from the Google Places API.
 */

export function useGetAutoCompleteLocations<TData = Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError = unknown>(
 params: MaybeRef<GetAutoCompleteLocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutoCompleteLocations>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAutoCompleteLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Get location details (including Lat, Long) from the Google Places API based on the place Id.
 */
export const getGetLocationDetailsUrl = (params: GetLocationDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/details/v2?${stringifiedParams}` : `/location/details/v2`
}

export const getLocationDetails = async (params: GetLocationDetailsParams, options?: RequestInit): Promise<GetLocationDetailsResult> => {
  
  return fetchWithAuth<GetLocationDetailsResult>(getGetLocationDetailsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetLocationDetailsQueryKey = (params?: MaybeRef<GetLocationDetailsParams>,) => {
    return [
    'location','details','v2', ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLocationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getLocationDetails>>, TError = unknown>(params: MaybeRef<GetLocationDetailsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLocationDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationDetails>>> = ({ signal }) => getLocationDetails(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData> 
}

export type GetLocationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationDetails>>>
export type GetLocationDetailsQueryError = unknown


/**
 * @summary Get location details (including Lat, Long) from the Google Places API based on the place Id.
 */

export function useGetLocationDetails<TData = Awaited<ReturnType<typeof getLocationDetails>>, TError = unknown>(
 params: MaybeRef<GetLocationDetailsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationDetails>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Get a location geocode (including Lat, Long) from the Google Places API based on the lat long.
 */
export const getGetLocationGeocodeUrl = (params?: GetLocationGeocodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/location/location-geocode?${stringifiedParams}` : `/location/location-geocode`
}

export const getLocationGeocode = async (params?: GetLocationGeocodeParams, options?: RequestInit): Promise<GetLocationGeocodeResult> => {
  
  return fetchWithAuth<GetLocationGeocodeResult>(getGetLocationGeocodeUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetLocationGeocodeQueryKey = (params?: MaybeRef<GetLocationGeocodeParams>,) => {
    return [
    'location','location-geocode', ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLocationGeocodeQueryOptions = <TData = Awaited<ReturnType<typeof getLocationGeocode>>, TError = unknown>(params?: MaybeRef<GetLocationGeocodeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetLocationGeocodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationGeocode>>> = ({ signal }) => getLocationGeocode(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData> 
}

export type GetLocationGeocodeQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationGeocode>>>
export type GetLocationGeocodeQueryError = unknown


/**
 * @summary Get a location geocode (including Lat, Long) from the Google Places API based on the lat long.
 */

export function useGetLocationGeocode<TData = Awaited<ReturnType<typeof getLocationGeocode>>, TError = unknown>(
 params?: MaybeRef<GetLocationGeocodeParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGeocode>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationGeocodeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListSkillsForInterestsUrl = (params?: ListSkillsForInterestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["interestIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/skill/v2/list-for-interests?${stringifiedParams}` : `/skill/v2/list-for-interests`
}

export const listSkillsForInterests = async (params?: ListSkillsForInterestsParams, options?: RequestInit): Promise<ListSkillsForInterestsResult> => {
  
  return fetchWithAuth<ListSkillsForInterestsResult>(getListSkillsForInterestsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListSkillsForInterestsQueryKey = (params?: MaybeRef<ListSkillsForInterestsParams>,) => {
    return [
    'skill','v2','list-for-interests', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSkillsForInterestsQueryOptions = <TData = Awaited<ReturnType<typeof listSkillsForInterests>>, TError = unknown>(params?: MaybeRef<ListSkillsForInterestsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSkillsForInterestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillsForInterests>>> = ({ signal }) => listSkillsForInterests(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillsForInterests>>, TError, TData> 
}

export type ListSkillsForInterestsQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillsForInterests>>>
export type ListSkillsForInterestsQueryError = unknown



export function useListSkillsForInterests<TData = Awaited<ReturnType<typeof listSkillsForInterests>>, TError = unknown>(
 params?: MaybeRef<ListSkillsForInterestsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSkillsForInterestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListSkillsForJobCategoriesUrl = (params?: ListSkillsForJobCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["jobCategoryIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/skill/v2/list-for-job-categories?${stringifiedParams}` : `/skill/v2/list-for-job-categories`
}

export const listSkillsForJobCategories = async (params?: ListSkillsForJobCategoriesParams, options?: RequestInit): Promise<ListSkillsForJobCategoriesResult> => {
  
  return fetchWithAuth<ListSkillsForJobCategoriesResult>(getListSkillsForJobCategoriesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListSkillsForJobCategoriesQueryKey = (params?: MaybeRef<ListSkillsForJobCategoriesParams>,) => {
    return [
    'skill','v2','list-for-job-categories', ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSkillsForJobCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError = unknown>(params?: MaybeRef<ListSkillsForJobCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListSkillsForJobCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillsForJobCategories>>> = ({ signal }) => listSkillsForJobCategories(unref(params), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData> 
}

export type ListSkillsForJobCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillsForJobCategories>>>
export type ListSkillsForJobCategoriesQueryError = unknown



export function useListSkillsForJobCategories<TData = Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError = unknown>(
 params?: MaybeRef<ListSkillsForJobCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsForJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSkillsForJobCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getListJobFunctionsUrl = () => {


  

  return `/job-function`
}

export const listJobFunctions = async ( options?: RequestInit): Promise<JobFunctionCrudListResult[]> => {
  
  return fetchWithAuth<JobFunctionCrudListResult[]>(getListJobFunctionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListJobFunctionsQueryKey = () => {
    return [
    'job-function'
    ] as const;
    }

    
export const getListJobFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof listJobFunctions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobFunctionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobFunctions>>> = ({ signal }) => listJobFunctions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData> 
}

export type ListJobFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobFunctions>>>
export type ListJobFunctionsQueryError = unknown



export function useListJobFunctions<TData = Awaited<ReturnType<typeof listJobFunctions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobFunctions>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobFunctionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




export const getGetJobFunctionUrl = (id: number,) => {


  

  return `/job-function/${id}`
}

export const getJobFunction = async (id: number, options?: RequestInit): Promise<JobFunctionCrudJobFunctionDto> => {
  
  return fetchWithAuth<JobFunctionCrudJobFunctionDto>(getGetJobFunctionUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetJobFunctionQueryKey = (id?: MaybeRef<number>,) => {
    return [
    'job-function',id
    ] as const;
    }

    
export const getGetJobFunctionQueryOptions = <TData = Awaited<ReturnType<typeof getJobFunction>>, TError = unknown>(id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobFunction>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobFunctionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobFunction>>> = ({ signal }) => getJobFunction(unref(id), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobFunction>>, TError, TData> 
}

export type GetJobFunctionQueryResult = NonNullable<Awaited<ReturnType<typeof getJobFunction>>>
export type GetJobFunctionQueryError = unknown



export function useGetJobFunction<TData = Awaited<ReturnType<typeof getJobFunction>>, TError = unknown>(
 id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobFunction>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobFunctionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all job categories, along with their job functions and skills
 */
export const getListJobCategoriesUrl = () => {


  

  return `/job-category/v2`
}

export const listJobCategories = async ( options?: RequestInit): Promise<JobCategoryCrudListResult> => {
  
  return fetchWithAuth<JobCategoryCrudListResult>(getListJobCategoriesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListJobCategoriesQueryKey = () => {
    return [
    'job-category','v2'
    ] as const;
    }

    
export const getListJobCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listJobCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListJobCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobCategories>>> = ({ signal }) => listJobCategories({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData> 
}

export type ListJobCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listJobCategories>>>
export type ListJobCategoriesQueryError = unknown


/**
 * @summary List all job categories, along with their job functions and skills
 */

export function useListJobCategories<TData = Awaited<ReturnType<typeof listJobCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobCategories>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List a job category, along with their job functions and skills
 */
export const getGetJobCategoryUrl = (id: number,) => {


  

  return `/job-category/v2/${id}`
}

export const getJobCategory = async (id: number, options?: RequestInit): Promise<JobCategoryCrudJobCategoryDto> => {
  
  return fetchWithAuth<JobCategoryCrudJobCategoryDto>(getGetJobCategoryUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetJobCategoryQueryKey = (id?: MaybeRef<number>,) => {
    return [
    'job-category','v2',id
    ] as const;
    }

    
export const getGetJobCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getJobCategory>>, TError = unknown>(id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetJobCategoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobCategory>>> = ({ signal }) => getJobCategory(unref(id), { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData> 
}

export type GetJobCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getJobCategory>>>
export type GetJobCategoryQueryError = unknown


/**
 * @summary List a job category, along with their job functions and skills
 */

export function useGetJobCategory<TData = Awaited<ReturnType<typeof getJobCategory>>, TError = unknown>(
 id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobCategory>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobCategoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List all interests
 */
export const getListInterestsUrl = () => {


  

  return `/interest`
}

export const listInterests = async ( options?: RequestInit): Promise<ListInterestsResult> => {
  
  return fetchWithAuth<ListInterestsResult>(getListInterestsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListInterestsQueryKey = () => {
    return [
    'interest'
    ] as const;
    }

    
export const getListInterestsQueryOptions = <TData = Awaited<ReturnType<typeof listInterests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getListInterestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterests>>> = ({ signal }) => listInterests({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData> 
}

export type ListInterestsQueryResult = NonNullable<Awaited<ReturnType<typeof listInterests>>>
export type ListInterestsQueryError = unknown


/**
 * @summary List all interests
 */

export function useListInterests<TData = Awaited<ReturnType<typeof listInterests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterests>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInterestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Get the role of the current user.
 */
export const getGetRoleUrl = () => {


  

  return `/user/account/role`
}

export const getRole = async ( options?: RequestInit): Promise<GetRoleResult> => {
  
  return fetchWithAuth<GetRoleResult>(getGetRoleUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetRoleQueryKey = () => {
    return [
    'user','account','role'
    ] as const;
    }

    
export const getGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetRoleQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRole>>> = ({ signal }) => getRole({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData> 
}

export type GetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRole>>>
export type GetRoleQueryError = unknown


/**
 * @summary Get the role of the current user.
 */

export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof fetchWithAuth>}
 , queryClient?: QueryClient 
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}


export const getGetUserCommentsResponseMock = (overrideResponse: Partial< GetUserCommentsResult > = {}): GetUserCommentsResult => ({comments: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), employerId: faker.number.int({min: undefined, max: undefined}), employerName: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), job: {id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), updatedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), isOwnComment: faker.datatype.boolean()})), ...overrideResponse})

export const getListAllSkillsResponseMock = (overrideResponse: Partial< ListAllSkillsResult > = {}): ListAllSkillsResult => ({softSkills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), languages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), hardSkills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}}), jobCategoryId: faker.number.int({min: undefined, max: undefined})})), ...overrideResponse})

export const getListEducationLevelsWithTrackCategoryResponseMock = (overrideResponse: Partial< ListEducationLevelsWithTrackCategoryResult > = {}): ListEducationLevelsWithTrackCategoryResult => ({educationLevels: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), trackCategory: faker.helpers.arrayElement(Object.values(TrackCategory))})), ...overrideResponse})

export const getListPaymentOptionsResponseMock = (overrideResponse: Partial< ListPaymentOptionsResult > = {}): ListPaymentOptionsResult => ({discount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), creditPackages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), creditAmount: faker.number.int({min: undefined, max: undefined}), creditPrice: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), totalPrice: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})})), jobSlotOptions: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), subscriptions: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), price: faker.number.int({min: undefined, max: undefined}), billingPeriodMonths: faker.number.int({min: undefined, max: undefined}), features: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), discountFraction: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), includesVideo: faker.datatype.boolean(), jobSlots: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])})), ...overrideResponse})

export const getCreateEmployerResponseMock = (overrideResponse: Partial< CreateEmployerResponse > = {}): CreateEmployerResponse => ({companyId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getGetEmployerOnboardingStatusResponseMock = (overrideResponse: Partial< GetEmployerOnboardingStatusResult > = {}): GetEmployerOnboardingStatusResult => ({status: faker.helpers.arrayElement(Object.values(EmployerOnboardingStatus)), employerInvite: faker.helpers.arrayElement([{type: faker.helpers.arrayElement(Object.values(EmployerInviteType)), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), invitedBy: faker.string.alpha({length: {min: 10, max: 20}}), invitedByCompany: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), employer: faker.helpers.arrayElement([{firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getListAllMatchesResponseMock = (overrideResponse: Partial< ListMatchesResult > = {}): ListMatchesResult => ({count: faker.number.int({min: undefined, max: undefined}), totalCount: faker.number.int({min: undefined, max: undefined}), hasClosedMatches: faker.datatype.boolean(), matches: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({info: {id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), unreadCount: faker.number.int({min: undefined, max: undefined}), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int({min: undefined, max: undefined}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`)}, job: {id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, markedAsUnreadUser: faker.datatype.boolean()})), ...overrideResponse})

export const getGetMatchedUserResponseMock = (overrideResponse: Partial< GetMatchedUserResult > = {}): GetMatchedUserResult => ({userId: faker.number.int({min: undefined, max: undefined}), cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int({min: undefined, max: undefined}), isSearchEverywhere: faker.datatype.boolean(), skills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), topSkills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, hoursPerWeek: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.number.int({min: undefined, max: undefined})}, educationLevel: faker.number.int({min: undefined, max: undefined}), personalCharacteristics: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), personalityTypeId: faker.number.int({min: undefined, max: undefined}), educationExperiences: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), studyAndGrade: faker.string.alpha({length: {min: 1, max: 20}}), institute: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900, max: undefined}), endYear: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), isGraduated: faker.datatype.boolean()})), noEducationExperience: faker.datatype.boolean(), workExperiences: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), type: faker.helpers.arrayElement(Object.values(WorkExperienceType)), functionTitle: faker.string.alpha({length: {min: 1, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), company: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900, max: undefined}), endYear: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])})), noWorkExperience: faker.datatype.boolean(), workExperienceComplete: faker.datatype.boolean(), ambitions: faker.string.alpha({length: {min: 10, max: 20}}), personalInterests: faker.string.alpha({length: {min: 10, max: 20}}), newJobReason: faker.string.alpha({length: {min: 10, max: 20}}), isCompleteProfileRequestSent: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean(), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), id: faker.number.int({min: undefined, max: undefined}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), age: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), email: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getGetMatchChatWithMessagesForEmployerResponseMock = (overrideResponse: Partial< GetMatchChatWithMessagesResult > = {}): GetMatchChatWithMessagesResult => ({contactInfo: {displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean()}, state: {suggestedAndHasNegativeCredits: faker.datatype.boolean(), isClosed: faker.datatype.boolean(), closedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), closureReason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(EmployerMatchClosureReason)), undefined]), isAtsJobApplication: faker.datatype.boolean(), atsJobApplicationUrl: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined])}, chat: {info: {id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), unreadCount: faker.number.int({min: undefined, max: undefined}), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int({min: undefined, max: undefined}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`)}, job: {id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, markedAsUnreadUser: faker.datatype.boolean()}, messages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), chatId: faker.number.int({min: undefined, max: undefined}), employerId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), userId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), poll: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), matchId: faker.number.int({min: undefined, max: undefined}), dates: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (new Date(`${faker.date.past().toISOString().split('.')[0]}Z`))), selectedDate: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), answeredAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, undefined])})), ...overrideResponse})

export const getSendMatchChatMessageForEmployerResponseMock = (overrideResponse: Partial< ChatMessageDto > = {}): ChatMessageDto => ({id: faker.number.int({min: undefined, max: undefined}), chatId: faker.number.int({min: undefined, max: undefined}), employerId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), userId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), poll: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), matchId: faker.number.int({min: undefined, max: undefined}), dates: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (new Date(`${faker.date.past().toISOString().split('.')[0]}Z`))), selectedDate: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), answeredAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, undefined]), ...overrideResponse})

export const getSendPollResponseMock = (overrideResponse: Partial< SendPollResult > = {}): SendPollResult => ({chatMessageId: faker.number.int({min: undefined, max: undefined}), pollId: faker.number.int({min: undefined, max: undefined}), matchId: faker.number.int({min: undefined, max: undefined}), ...overrideResponse})

export const getGetLeadEmployerResponseMock = (overrideResponse: Partial< GetLeadEmployerResult > = {}): GetLeadEmployerResult => ({firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), hasAccount: faker.datatype.boolean(), ...overrideResponse})

export const getCreateFirebaseAccountForLeadResponseMock = (overrideResponse: Partial< CreateFirebaseAccountForLeadResult > = {}): CreateFirebaseAccountForLeadResult => ({token: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getListJobsResponseMock = (overrideResponse: Partial< ListJobsInPortalResult > = {}): ListJobsInPortalResult => ({count: faker.number.int({min: undefined, max: undefined}), totalCount: faker.number.int({min: undefined, max: undefined}), jobs: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), description: {title: faker.string.alpha({length: {min: 10, max: 20}}), opening: faker.string.alpha({length: {min: 10, max: 20}}), duties: faker.string.alpha({length: {min: 10, max: 20}}), requirements: faker.string.alpha({length: {min: 10, max: 20}}), benefitsAndPerks: faker.string.alpha({length: {min: 10, max: 20}}), closing: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), publishedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), visibleBetween: faker.helpers.arrayElement([{start: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), end: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, undefined]), closedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), status: faker.helpers.arrayElement(Object.values(JobStatus)), closureReason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(JobClosureReason)), undefined]), locationNames: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), jobCategoryCode: faker.string.alpha({length: {min: 10, max: 20}}), jobCategoryId: faker.number.int({min: undefined, max: undefined}), jobFunctionId: faker.number.int({min: undefined, max: undefined}), waitingJobApplicationCount: faker.number.int({min: undefined, max: undefined}), promptFlowRunId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.uuid(), null]), undefined]), atsJob: faker.helpers.arrayElement([{id: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), status: faker.helpers.arrayElement(Object.values(AtsJobMappingStatus))}, undefined])})), ...overrideResponse})

export const getCreateJobResponseMock = (): number => (faker.number.int())

export const getUpdateJobResponseMock = (): number => (faker.number.int())

export const getGetJobResponseMock = (overrideResponse: Partial< GetJobResult > = {}): GetJobResult => ({id: faker.number.int({min: undefined, max: undefined}), description: {title: faker.string.alpha({length: {min: 10, max: 20}}), opening: faker.string.alpha({length: {min: 10, max: 20}}), duties: faker.string.alpha({length: {min: 10, max: 20}}), requirements: faker.string.alpha({length: {min: 10, max: 20}}), benefitsAndPerks: faker.string.alpha({length: {min: 10, max: 20}}), closing: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), publishedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), visibleBetween: faker.helpers.arrayElement([{start: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), end: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, undefined]), closedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), status: faker.helpers.arrayElement(Object.values(JobStatus)), closureReason: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(JobClosureReason)), undefined]), locations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), longitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}})), isRemote: faker.datatype.boolean(), jobCategoryId: faker.number.int({min: undefined, max: undefined}), jobFunctionId: faker.number.int({min: undefined, max: undefined}), educationLevels: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, salary: {lower: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), upper: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, salaryPeriodicity: faker.helpers.arrayElement(Object.values(Periodicity)), hoursPerWeek: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.number.int({min: undefined, max: undefined})}, preferredCharacteristicColor: faker.helpers.arrayElement(Object.values(CharacteristicColor)), skills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), waitingJobApplicationCount: faker.number.int({min: undefined, max: undefined}), rejectedJobApplicationCount: faker.number.int({min: undefined, max: undefined}), matchesCount: faker.number.int({min: undefined, max: undefined}), isSubscribed: faker.datatype.boolean(), atsJob: faker.helpers.arrayElement([{id: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), status: faker.helpers.arrayElement(Object.values(AtsJobMappingStatus))}, undefined]), ...overrideResponse})

export const getListJobApplicationsForJobResponseMock = (overrideResponse: Partial< ListJobApplicationsForJobResult > = {}): ListJobApplicationsForJobResult => ({jobId: faker.number.int({min: undefined, max: undefined}), jobApplications: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), status: faker.helpers.arrayElement(Object.values(JobApplicationState)), candidate: {cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int({min: undefined, max: undefined}), yearsExperience: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, educationLevel: faker.number.int({min: undefined, max: undefined}), personalCharacteristics: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), personalityTypeId: faker.number.int({min: undefined, max: undefined}), lastFunctionTitle: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined])}, matchScoreTotal: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})})), ...overrideResponse})

export const getListMatchesForJobResponseMock = (overrideResponse: Partial< ListMatchesForJobResult > = {}): ListMatchesForJobResult => ({jobId: faker.number.int({min: undefined, max: undefined}), matches: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), closedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), lastMessageAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), unreadMessageCount: faker.number.int({min: undefined, max: undefined}), user: {id: faker.number.int({min: undefined, max: undefined}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int({min: undefined, max: undefined}), email: faker.string.alpha({length: {min: 10, max: 20}}), dateOfBirth: new Date(faker.date.past().toISOString().split('T')[0]), yearsExperience: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, educationLevelId: faker.number.int({min: undefined, max: undefined}), ambitions: faker.string.alpha({length: {min: 10, max: 20}}), personalInterests: faker.string.alpha({length: {min: 10, max: 20}}), newJobReason: faker.string.alpha({length: {min: 10, max: 20}}), lastFunctionTitle: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), personalCharacteristics: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), personalityTypeId: faker.number.int({min: undefined, max: undefined})}})), ...overrideResponse})

export const getUpdateJobPublishedResponseMock = (): UpdateJobPublishedResult => ({})

export const getFindBestCandidateResponseMock = (overrideResponse: Partial< FindBestCandidateResult > = {}): FindBestCandidateResult => ({matchScoreId: faker.number.int({min: undefined, max: undefined}), user: {userId: faker.number.int({min: undefined, max: undefined}), cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int({min: undefined, max: undefined}), isSearchEverywhere: faker.datatype.boolean(), skills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), topSkills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, hoursPerWeek: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.number.int({min: undefined, max: undefined})}, educationLevel: faker.number.int({min: undefined, max: undefined}), personalCharacteristics: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), personalityTypeId: faker.number.int({min: undefined, max: undefined}), educationExperiences: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), studyAndGrade: faker.string.alpha({length: {min: 1, max: 20}}), institute: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900, max: undefined}), endYear: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), isGraduated: faker.datatype.boolean()})), noEducationExperience: faker.datatype.boolean(), workExperiences: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), type: faker.helpers.arrayElement(Object.values(WorkExperienceType)), functionTitle: faker.string.alpha({length: {min: 1, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), company: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900, max: undefined}), endYear: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])})), noWorkExperience: faker.datatype.boolean(), workExperienceComplete: faker.datatype.boolean(), ambitions: faker.string.alpha({length: {min: 10, max: 20}}), personalInterests: faker.string.alpha({length: {min: 10, max: 20}}), newJobReason: faker.string.alpha({length: {min: 10, max: 20}}), isCompleteProfileRequestSent: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean(), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), usageStatistics: {likeFractionLast14Days: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), likeCountLast14Days: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}}, matchScoreTotal: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), ...overrideResponse})

export const getReactToBestCandidateResponseMock = (): ReactToCandidateResult => ({})

export const getGetJobNotificationSettingsResponseMock = (overrideResponse: Partial< GetJobNotificationSettingsResult > = {}): GetJobNotificationSettingsResult => ({teammates: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), isSubscribed: faker.datatype.boolean()})), ...overrideResponse})

export const getGetJobApplicationResponseMock = (overrideResponse: Partial< GetJobApplicationResult > = {}): GetJobApplicationResult => ({id: faker.number.int({min: undefined, max: undefined}), jobId: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), respondedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), status: faker.helpers.arrayElement(Object.values(JobApplicationState)), matchId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), user: {userId: faker.number.int({min: undefined, max: undefined}), cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int({min: undefined, max: undefined}), isSearchEverywhere: faker.datatype.boolean(), skills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), topSkills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), yearsExperience: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, hoursPerWeek: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.number.int({min: undefined, max: undefined})}, educationLevel: faker.number.int({min: undefined, max: undefined}), personalCharacteristics: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), personalityTypeId: faker.number.int({min: undefined, max: undefined}), educationExperiences: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), studyAndGrade: faker.string.alpha({length: {min: 1, max: 20}}), institute: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900, max: undefined}), endYear: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), isGraduated: faker.datatype.boolean()})), noEducationExperience: faker.datatype.boolean(), workExperiences: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), type: faker.helpers.arrayElement(Object.values(WorkExperienceType)), functionTitle: faker.string.alpha({length: {min: 1, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), company: faker.string.alpha({length: {min: 1, max: 20}}), startYear: faker.number.int({min: 1900, max: undefined}), endYear: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])})), noWorkExperience: faker.datatype.boolean(), workExperienceComplete: faker.datatype.boolean(), ambitions: faker.string.alpha({length: {min: 10, max: 20}}), personalInterests: faker.string.alpha({length: {min: 10, max: 20}}), newJobReason: faker.string.alpha({length: {min: 10, max: 20}}), isCompleteProfileRequestSent: faker.datatype.boolean(), prefersContactOverPhone: faker.datatype.boolean(), allowPhoneCalls: faker.datatype.boolean(), allowTexts: faker.datatype.boolean(), usageStatistics: {likeFractionLast14Days: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), likeCountLast14Days: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}}, matchScoreTotal: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), ...overrideResponse})

export const getListAllWaitingJobApplicationsResponseMock = (overrideResponse: Partial< ListAllWaitingJobApplicationsResult > = {}): ListAllWaitingJobApplicationsResult => ({jobApplications: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), job: {id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), jobCategoryId: faker.number.int({min: undefined, max: undefined}), jobFunctionId: faker.number.int({min: undefined, max: undefined})}, status: faker.helpers.arrayElement(Object.values(JobApplicationState)), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), candidate: {cityName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationName: faker.string.alpha({length: {min: 10, max: 20}}), searchLocationRadius: faker.number.int({min: undefined, max: undefined}), yearsExperience: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, educationLevel: faker.number.int({min: undefined, max: undefined}), personalCharacteristics: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.number.int({min: undefined, max: undefined}))), personalityTypeId: faker.number.int({min: undefined, max: undefined}), lastFunctionTitle: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined])}, matchScoreTotal: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})})), ...overrideResponse})

export const getListJobApplicationRejectionReasonsResponseMock = (overrideResponse: Partial< ListJobApplicationRejectionReasonsResult > = {}): ListJobApplicationRejectionReasonsResult => ({rejectionReasons: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getRejectJobApplicationResponseMock = (overrideResponse: Partial< RejectJobApplicationResult > = {}): RejectJobApplicationResult => ({id: faker.number.int({min: undefined, max: undefined}), ...overrideResponse})

export const getStartMatchResponseMock = (overrideResponse: Partial< StartMatchResult > = {}): StartMatchResult => ({id: faker.number.int({min: undefined, max: undefined}), matchId: faker.number.int({min: undefined, max: undefined}), ...overrideResponse})

export const getListCreditTransactionsResponseMock = (overrideResponse: Partial< ListCreditTransactionsResult > = {}): ListCreditTransactionsResult => ({creditTotal: faker.number.int({min: undefined, max: undefined}), creditTransactions: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), creditAmount: faker.number.int({min: undefined, max: undefined}), creditPrice: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), totalPrice: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})})), ...overrideResponse})

export const getGetSubscriptionResponseMock = (overrideResponse: Partial< GetSubscriptionResult > = {}): GetSubscriptionResult => ({subscription: faker.helpers.arrayElement([{id: faker.string.uuid(), title: faker.string.alpha({length: {min: 10, max: 20}}), invoicee: {customer: {id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}})}}, status: faker.helpers.arrayElement(Object.values(SubscriptionStatus)), next_renewal_date: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), starts_on: new Date(faker.date.past().toISOString().split('T')[0]), ends_on: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(faker.date.past().toISOString().split('T')[0]), null]), undefined]), billing_cycle: {periodicity: {unit: faker.string.alpha({length: {min: 10, max: 20}}), period: faker.number.int({min: undefined, max: undefined})}, days_in_advance: faker.number.int({min: undefined, max: undefined})}, grouped_lines: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({line_items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({product_category: {id: faker.string.uuid(), type: faker.string.alpha({length: {min: 10, max: 20}})}, quantity: faker.number.int({min: undefined, max: undefined}), description: faker.string.alpha({length: {min: 10, max: 20}}), unit_price: {amount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), currency: faker.string.alpha({length: {min: 10, max: 20}}), tax: faker.string.alpha({length: {min: 10, max: 20}})}, total: faker.helpers.arrayElement([{tax_exclusive: {amount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, tax_inclusive: {amount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, due: faker.helpers.arrayElement([{amount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, undefined])}, undefined])}))})), total: {tax_exclusive: {amount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, tax_inclusive: {amount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, due: faker.helpers.arrayElement([{amount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, undefined])}}, undefined]), ...overrideResponse})

export const getListCompanySubscriptionsResponseMock = (overrideResponse: Partial< ListCompanySubscriptionsResult > = {}): ListCompanySubscriptionsResult => ({results: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({subscriptionId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.uuid(), null]), undefined]), name: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(SubscriptionStatus)), startDate: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), endDate: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), jobSlots: faker.number.int({min: undefined, max: undefined}), durationInMonths: faker.number.int({min: undefined, max: undefined}), pricePerMonthExclVat: faker.number.int({min: undefined, max: undefined})})), ...overrideResponse})

export const getListInvoicesForCompanyResponseMock = (overrideResponse: Partial< ListInvoicesForCompanyResult > = {}): ListInvoicesForCompanyResult => ({invoices: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({invoiceNumber: faker.string.alpha({length: {min: 10, max: 20}}), invoiceDate: new Date(faker.date.past().toISOString().split('T')[0]), status: faker.helpers.arrayElement(Object.values(InvoiceStatus)), paid: faker.datatype.boolean(), dueOn: new Date(faker.date.past().toISOString().split('T')[0]), daysOverdue: faker.number.int({min: undefined, max: undefined}), totalAmount: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), due: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), fileId: faker.string.uuid()})), ...overrideResponse})

export const getGetInvoiceFileUrlResponseMock = (overrideResponse: Partial< GetInvoiceFileUrlResult > = {}): GetInvoiceFileUrlResult => ({fileUrl: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getListIntegrationsResponseMock = (overrideResponse: Partial< ListIntegrationsResult > = {}): ListIntegrationsResult => ({integrations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({type: faker.helpers.arrayElement(Object.values(IntegrationType)), name: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}}), websiteUrl: faker.string.alpha({length: {min: 10, max: 20}}), iconSvgPath: faker.string.alpha({length: {min: 10, max: 20}}), visibility: faker.helpers.arrayElement(Object.values(IntegrationVisibility)), connection: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), lastSyncAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, undefined])})), ...overrideResponse})

export const getConnectHomerunIntegrationResponseMock = (overrideResponse: Partial< IntegrationConnectionDto > = {}): IntegrationConnectionDto => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), lastSyncAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), ...overrideResponse})

export const getUpdateHomerunConnectionResponseMock = (): Unit => ({})

export const getGetHomerunConnectionResponseMock = (overrideResponse: Partial< GetAtsIntegrationConnectionResultHomerunConnectionConfig > = {}): GetAtsIntegrationConnectionResultHomerunConnectionConfig => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{isJobImportEnabled: faker.datatype.boolean(), isCandidateExportEnabled: faker.datatype.boolean()}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), lastSyncAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), ...overrideResponse})

export const getDeleteIntegrationConnectionResponseMock = (): Unit => ({})

export const getListAtsJobsResponseMock = (overrideResponse: Partial< ListAtsJobsResult > = {}): ListAtsJobsResult => ({jobs: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), title: faker.string.alpha({length: {min: 10, max: 20}}), location: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), status: faker.helpers.arrayElement(Object.values(AtsJobMappingStatus))})), ...overrideResponse})

export const getMapJobWithAtsJobResponseMock = (): Unit => ({})

export const getConnectRecruiteeIntegrationResponseMock = (overrideResponse: Partial< IntegrationConnectionDto > = {}): IntegrationConnectionDto => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), createdBy: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), lastSyncAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), ...overrideResponse})

export const getUpdateRecruiteeConnectionResponseMock = (): Unit => ({})

export const getGetRecruiteeConnectionResponseMock = (overrideResponse: Partial< GetAtsIntegrationConnectionResultRecruiteeConnectionConfig > = {}): GetAtsIntegrationConnectionResultRecruiteeConnectionConfig => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(IntegrationType)), status: faker.helpers.arrayElement(Object.values(ConnectionStatus)), config: faker.helpers.arrayElement([{isMergeDuplicateCandidatesEnabled: faker.datatype.boolean()}, undefined]), defaultMessageDto: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))}, undefined]), createdByEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, sendAsEmployer: {role: faker.helpers.arrayElement(Object.values(Role)), id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})}, createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), lastSyncAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), ...overrideResponse})

export const getListReferralInvitesResponseMock = (overrideResponse: Partial< ListReferralInvitesResult > = {}): ListReferralInvitesResult => ({invites: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({email: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), isCompleted: faker.datatype.boolean()})), ...overrideResponse})

export const getGetEmployerAccessResponseMock = (overrideResponse: Partial< GetEmployerAccessResult > = {}): GetEmployerAccessResult => ({canAccessOtherCompanies: faker.datatype.boolean(), permissions: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({resource: faker.helpers.arrayElement(Object.values(PermissionResource)), level: faker.helpers.arrayElement(Object.values(PermissionLevel))})), roles: faker.helpers.arrayElements(Object.values(EmployerRole)), ...overrideResponse})

export const getGetProfileResponseMock = (overrideResponse: Partial< GetEmployerProfileResult > = {}): GetEmployerProfileResult => ({id: faker.number.int({min: undefined, max: undefined}), externalId: faker.string.alpha({length: {min: 10, max: 20}}), firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}}), reportingPeriodicity: faker.helpers.arrayElement(Object.values(ReportingPeriodicity)), companyId: faker.number.int({min: undefined, max: undefined}), companyName: faker.string.alpha({length: {min: 10, max: 20}}), companySettings: {}, originalCompanyId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), originalCompanyName: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), hasSubscription: faker.datatype.boolean(), ...overrideResponse})

export const getUpdateProfileResponseMock = (): number => (faker.number.int())

export const getGetStatisticsResponseMock = (overrideResponse: Partial< GetCompanyStatisticsResult > = {}): GetCompanyStatisticsResult => ({waitingJobApplicationCount: faker.number.int({min: undefined, max: undefined}), totalJobApplicationCount: faker.number.int({min: undefined, max: undefined}), publishedJobCount: faker.number.int({min: undefined, max: undefined}), unhandledMatchCount: faker.number.int({min: undefined, max: undefined}), totalMatchCount: faker.number.int({min: undefined, max: undefined}), ...overrideResponse})

export const getListUnhandledJobsResponseMock = (overrideResponse: Partial< ListUnhandledJobsResult > = {}): ListUnhandledJobsResult => ({jobs: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), title: faker.string.alpha({length: {min: 10, max: 20}}), functionTitle: faker.string.alpha({length: {min: 10, max: 20}}), unhandledJobApplicationCount: faker.number.int({min: undefined, max: undefined}), lastApplicationAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`)})), ...overrideResponse})

export const getListUnhandledMatchesResponseMock = (overrideResponse: Partial< ListUnhandledMatchesResult > = {}): ListUnhandledMatchesResult => ({matches: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), profilePictureUrl: faker.string.alpha({length: {min: 10, max: 20}}), lastMessage: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), closedAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), userName: faker.string.alpha({length: {min: 10, max: 20}}), jobTitle: faker.string.alpha({length: {min: 10, max: 20}}), unreadMessageCount: faker.number.int({min: undefined, max: undefined})})), ...overrideResponse})

export const getGetConferenceInfoResponseMock = (overrideResponse: Partial< GetConferenceInfoResult > = {}): GetConferenceInfoResult => ({conference: faker.helpers.arrayElement([{conferenceId: faker.number.int({min: undefined, max: undefined}), date: {start: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), end: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, companyJobsVisibleWithinApp: {start: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), end: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, conferenceModuleVisibleWithinApp: {start: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), end: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, conferenceArea: faker.string.alpha({length: {min: 10, max: 20}}), standNumber: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), ...overrideResponse})

export const getListConferenceChatsEmployerResponseMock = (overrideResponse: Partial< ListConferenceChatsResult > = {}): ListConferenceChatsResult => ({chats: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({info: {id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), unreadCount: faker.number.int({min: undefined, max: undefined}), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int({min: undefined, max: undefined}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`)}, job: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, undefined])})), ...overrideResponse})

export const getSendConferenceChatMessageEmployerResponseMock = (overrideResponse: Partial< ChatMessageDto > = {}): ChatMessageDto => ({id: faker.number.int({min: undefined, max: undefined}), chatId: faker.number.int({min: undefined, max: undefined}), employerId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), userId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), poll: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), matchId: faker.number.int({min: undefined, max: undefined}), dates: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (new Date(`${faker.date.past().toISOString().split('.')[0]}Z`))), selectedDate: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), answeredAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, undefined]), ...overrideResponse})

export const getListUnreadConferenceChatsEmployerResponseMock = (overrideResponse: Partial< ListUnreadConferenceChatsResult > = {}): ListUnreadConferenceChatsResult => ({chats: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({info: {id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), unreadCount: faker.number.int({min: undefined, max: undefined}), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int({min: undefined, max: undefined}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`)}, job: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, undefined])})), ...overrideResponse})

export const getGetConferenceChatWithMessagesForEmployerResponseMock = (overrideResponse: Partial< GetConferenceChatWithMessagesForEmployerResult > = {}): GetConferenceChatWithMessagesForEmployerResult => ({chat: {info: {id: faker.number.int({min: undefined, max: undefined}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), unreadCount: faker.number.int({min: undefined, max: undefined}), otherParticipant: {viewingUserRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), id: faker.number.int({min: undefined, max: undefined}), displayName: faker.string.alpha({length: {min: 10, max: 20}}), imageUrl: faker.string.alpha({length: {min: 10, max: 20}})}, isUserResponseMissing: faker.datatype.boolean(), lastMessageBody: faker.string.alpha({length: {min: 10, max: 20}}), lastMessageAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`)}, job: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), subtitle: faker.string.alpha({length: {min: 10, max: 20}})}, undefined])}, messages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), chatId: faker.number.int({min: undefined, max: undefined}), employerId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), userId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), isRead: faker.datatype.boolean(), senderRole: faker.helpers.arrayElement(Object.values(ChatMessageSenderRole)), sender: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), createdAt: new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), poll: faker.helpers.arrayElement([{id: faker.number.int({min: undefined, max: undefined}), matchId: faker.number.int({min: undefined, max: undefined}), dates: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (new Date(`${faker.date.past().toISOString().split('.')[0]}Z`))), selectedDate: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined]), answeredAt: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(`${faker.date.past().toISOString().split('.')[0]}Z`), null]), undefined])}, undefined])})), ...overrideResponse})

export const getGetMyCompanyResponseMock = (overrideResponse: Partial< GetCompanyFromPortalResult > = {}): GetCompanyFromPortalResult => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), location: {id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), longitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}}, aboutUs: faker.string.alpha({length: {min: 10, max: 20}}), culture: faker.string.alpha({length: {min: 10, max: 20}}), employeeCount: {lower: faker.number.int({min: undefined, max: undefined}), upper: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined])}, employeeStory: faker.string.alpha({length: {min: 10, max: 20}}), employeeName: faker.string.alpha({length: {min: 10, max: 20}}), employeeFunction: faker.string.alpha({length: {min: 10, max: 20}}), logo: faker.helpers.arrayElement([{id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), cover: faker.helpers.arrayElement([{id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), employeeProfilePicture: faker.helpers.arrayElement([{id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})}, undefined]), generalImages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}})})), videoThumbnailUrl: faker.string.alpha({length: {min: 10, max: 20}}), videoUrl: faker.string.alpha({length: {min: 10, max: 20}}), defaultMessages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))})), accountManager: faker.helpers.arrayElement([{firstName: faker.string.alpha({length: {min: 10, max: 20}}), lastName: faker.string.alpha({length: {min: 10, max: 20}}), phoneNumber: faker.string.alpha({length: {min: 10, max: 20}}), profilePictureUrl: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined])}, undefined]), relatedCompanies: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getUpdateMyCompanyResponseMock = (): number => (faker.number.int())

export const getDeleteMyCompanyResponseMock = (): number => (faker.number.int())

export const getGetMyCompanyPlanResponseMock = (overrideResponse: Partial< GetCompanyPlanResult > = {}): GetCompanyPlanResult => ({hasSubscription: faker.datatype.boolean(), jobSlots: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), activeJobs: faker.number.int({min: undefined, max: undefined}), scoutCredits: faker.number.int({min: undefined, max: undefined}), matchCredits: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), canMatch: faker.datatype.boolean(), mainAtsIntegrationConnectionId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), integrationTypes: faker.helpers.arrayElements(Object.values(IntegrationType)), ...overrideResponse})

export const getListEmployersForCompanyResponseMock = (overrideResponse: Partial< ListOtherEmployersForCompanyResult > = {}): ListOtherEmployersForCompanyResult => ({employers: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), inviteId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), null]), undefined]), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getAddOrUpdateDefaultMessageResponseMock = (overrideResponse: Partial< AddOrUpdateDefaultMessageResult > = {}): AddOrUpdateDefaultMessageResult => ({defaultMessages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))})), ...overrideResponse})

export const getDeleteDefaultMessageResponseMock = (overrideResponse: Partial< DeleteDefaultMessageResult > = {}): DeleteDefaultMessageResult => ({defaultMessages: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), title: faker.string.alpha({length: {min: 10, max: 20}}), body: faker.string.alpha({length: {min: 10, max: 20}}), isPublic: faker.datatype.boolean(), messageType: faker.helpers.arrayElement(Object.values(DefaultMessageType))})), ...overrideResponse})

export const getUploadProvisionalImageResponseMock = (overrideResponse: Partial< ImageDto > = {}): ImageDto => ({id: faker.string.uuid(), fileName: faker.string.alpha({length: {min: 10, max: 20}}), url: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getSendRequestToAccountManagerResponseMock = (): Unit => ({})

export const getGetCompanyHireReportInfoResponseMock = (overrideResponse: Partial< GetCompanyHireReportInfoResult > = {}): GetCompanyHireReportInfoResult => ({firstDay: faker.helpers.arrayElement([faker.helpers.arrayElement([new Date(faker.date.past().toISOString().split('T')[0]), null]), undefined]), isFirstReport: faker.datatype.boolean(), hasMatches: faker.datatype.boolean(), ...overrideResponse})

export const getCreateCompanyHireReportResponseMock = (): CreateCompanyHireReport => ({})

export const getGetMatchingConfigurationResponseMock = (overrideResponse: Partial< GetCompanyMatchingConfigurationResult > = {}): GetCompanyMatchingConfigurationResult => ({matchingConfiguration: faker.helpers.arrayElement([{workExperienceImportance: faker.helpers.arrayElement(Object.values(FeatureImportance)), educationImportance: faker.helpers.arrayElement(Object.values(FeatureImportance)), hardSkillsImportance: faker.helpers.arrayElement(Object.values(FeatureImportance)), softSkillsImportance: faker.helpers.arrayElement(Object.values(FeatureImportance)), personalityImportance: faker.helpers.arrayElement(Object.values(FeatureImportance))}, undefined]), ...overrideResponse})

export const getListManagedCompaniesResponseMock = (overrideResponse: Partial< ListManagedCompaniesResult > = {}): ListManagedCompaniesResult => ({companies: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListEducationLevelsResponseMock = (overrideResponse: Partial< ListEducationLevelsResult > = {}): ListEducationLevelsResult => ({educationLevels: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListPersonalCharacteristicsResponseMock = (overrideResponse: Partial< ListPersonalCharacteristicsResult > = {}): ListPersonalCharacteristicsResult => ({personalCharacteristics: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), color: faker.helpers.arrayElement(Object.values(CharacteristicColor))})), ...overrideResponse})

export const getListNewJobReasonsResponseMock = (overrideResponse: Partial< ListNewJobReasonsResult > = {}): ListNewJobReasonsResult => ({newJobReasons: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListPersonalityTypesResponseMock = (overrideResponse: Partial< ListPersonalityTypesResult > = {}): ListPersonalityTypesResult => ({personalityTypes: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), summary: faker.string.alpha({length: {min: 10, max: 20}}), energizers: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), drainers: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))})), ...overrideResponse})

export const getGetAutoCompleteLocationsResponseMock = (overrideResponse: Partial< GetAutoCompleteLocationsResult > = {}): GetAutoCompleteLocationsResult => ({sessionToken: faker.string.uuid(), locations: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({placeId: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getGetLocationDetailsResponseMock = (overrideResponse: Partial< GetLocationDetailsResult > = {}): GetLocationDetailsResult => ({location: {id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), geolocation: {latitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), longitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}}, ...overrideResponse})

export const getGetLocationGeocodeResponseMock = (overrideResponse: Partial< GetLocationGeocodeResult > = {}): GetLocationGeocodeResult => ({coordinates: {latitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), longitude: faker.number.float({min: undefined, max: undefined, fractionDigits: 2})}, name: faker.string.alpha({length: {min: 10, max: 20}}), placeId: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getListSkillsForInterestsResponseMock = (overrideResponse: Partial< ListSkillsForInterestsResult > = {}): ListSkillsForInterestsResult => ({skills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListSkillsForJobCategoriesResponseMock = (overrideResponse: Partial< ListSkillsForJobCategoriesResult > = {}): ListSkillsForJobCategoriesResult => ({skills: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), type: faker.helpers.arrayElement(Object.values(SkillType)), name: faker.string.alpha({length: {min: 10, max: 20}}), tag: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListJobFunctionsResponseMock = (): JobFunctionCrudListResult[] => (Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({jobFunctions: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 1, max: 20}}), jobCategoryId: faker.number.int({min: undefined, max: undefined})}))})))

export const getGetJobFunctionResponseMock = (overrideResponse: Partial< JobFunctionCrudJobFunctionDto > = {}): JobFunctionCrudJobFunctionDto => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 1, max: 20}}), jobCategoryId: faker.number.int({min: undefined, max: undefined}), ...overrideResponse})

export const getListJobCategoriesResponseMock = (overrideResponse: Partial< JobCategoryCrudListResult > = {}): JobCategoryCrudListResult => ({jobCategories: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), categoryCode: faker.string.alpha({length: {min: 10, max: 20}}), defaultSalaryPeriodicity: faker.helpers.arrayElement(Object.values(Periodicity)), salaryConversionFactor: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), jobFunctions: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})}))})), ...overrideResponse})

export const getGetJobCategoryResponseMock = (overrideResponse: Partial< JobCategoryCrudJobCategoryDto > = {}): JobCategoryCrudJobCategoryDto => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}}), categoryCode: faker.string.alpha({length: {min: 10, max: 20}}), defaultSalaryPeriodicity: faker.helpers.arrayElement(Object.values(Periodicity)), salaryConversionFactor: faker.number.float({min: undefined, max: undefined, fractionDigits: 2}), jobFunctions: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getListInterestsResponseMock = (overrideResponse: Partial< ListInterestsResult > = {}): ListInterestsResult => ({interests: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({id: faker.number.int({min: undefined, max: undefined}), name: faker.string.alpha({length: {min: 10, max: 20}})})), ...overrideResponse})

export const getGetRoleResponseMock = (overrideResponse: Partial< GetRoleResult > = {}): GetRoleResult => ({role: faker.helpers.arrayElement(Object.values(Role)), ...overrideResponse})


export const getAddUserCommentMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/v1/employer/user/comments', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getGetUserCommentsMockHandler = (overrideResponse?: GetUserCommentsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetUserCommentsResult> | GetUserCommentsResult), options?: RequestHandlerOptions) => {
  return http.get('*/v1/employer/user/comments/:userId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetUserCommentsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getEditUserCommentMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.put('*/v1/employer/user/comments/:commentId', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getDeleteUserCommentMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/v1/employer/user/comments/:commentId', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getListAllSkillsMockHandler = (overrideResponse?: ListAllSkillsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListAllSkillsResult> | ListAllSkillsResult), options?: RequestHandlerOptions) => {
  return http.get('*/skill/v2', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAllSkillsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListEducationLevelsWithTrackCategoryMockHandler = (overrideResponse?: ListEducationLevelsWithTrackCategoryResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListEducationLevelsWithTrackCategoryResult> | ListEducationLevelsWithTrackCategoryResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/static-data/education-levels', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListEducationLevelsWithTrackCategoryResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getCreateCompanyForEmployerMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/employer-onboarding/create-company', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getListPaymentOptionsMockHandler = (overrideResponse?: ListPaymentOptionsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListPaymentOptionsResult> | ListPaymentOptionsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/employer-onboarding/payment-options', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListPaymentOptionsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getCreateEmployerMockHandler = (overrideResponse?: CreateEmployerResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<CreateEmployerResponse> | CreateEmployerResponse), options?: RequestHandlerOptions) => {
  return http.post('*/employer/v2/onboarding/register', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetEmployerOnboardingStatusMockHandler = (overrideResponse?: GetEmployerOnboardingStatusResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetEmployerOnboardingStatusResult> | GetEmployerOnboardingStatusResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/v2/onboarding', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetEmployerOnboardingStatusResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListAllMatchesMockHandler = (overrideResponse?: ListMatchesResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListMatchesResult> | ListMatchesResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/match', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAllMatchesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetMatchedUserMockHandler = (overrideResponse?: GetMatchedUserResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetMatchedUserResult> | GetMatchedUserResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/match/:id/user', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMatchedUserResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getMarkMatchAsReadOrUnreadMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/match/mark', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getCloseMatchMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/match/close', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getGetMatchChatWithMessagesForEmployerMockHandler = (overrideResponse?: GetMatchChatWithMessagesResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetMatchChatWithMessagesResult> | GetMatchChatWithMessagesResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/match/:id/chat', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMatchChatWithMessagesForEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getSendMatchChatMessageForEmployerMockHandler = (overrideResponse?: ChatMessageDto | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<ChatMessageDto> | ChatMessageDto), options?: RequestHandlerOptions) => {
  return http.post('*/employer/match/chat', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendMatchChatMessageForEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getSendPollMockHandler = (overrideResponse?: SendPollResult | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<SendPollResult> | SendPollResult), options?: RequestHandlerOptions) => {
  return http.post('*/employer/match/poll', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendPollResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetLeadEmployerMockHandler = (overrideResponse?: GetLeadEmployerResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetLeadEmployerResult> | GetLeadEmployerResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/lead/account', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetLeadEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getCreateFirebaseAccountForLeadMockHandler = (overrideResponse?: CreateFirebaseAccountForLeadResult | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<CreateFirebaseAccountForLeadResult> | CreateFirebaseAccountForLeadResult), options?: RequestHandlerOptions) => {
  return http.post('*/employer/lead/account', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateFirebaseAccountForLeadResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getConvertLeadCompanyToRegularMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/lead/company', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getListJobsMockHandler = (overrideResponse?: ListJobsInPortalResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListJobsInPortalResult> | ListJobsInPortalResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getCreateJobMockHandler = (overrideResponse?: number | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.post('*/employer/job', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateJobResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateJobMockHandler = (overrideResponse?: number | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.put('*/employer/job', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateJobResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetJobMockHandler = (overrideResponse?: GetJobResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetJobResult> | GetJobResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job/:id', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListJobApplicationsForJobMockHandler = (overrideResponse?: ListJobApplicationsForJobResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListJobApplicationsForJobResult> | ListJobApplicationsForJobResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job/:jobId/job-applications', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobApplicationsForJobResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListMatchesForJobMockHandler = (overrideResponse?: ListMatchesForJobResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListMatchesForJobResult> | ListMatchesForJobResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job/:jobId/matches', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListMatchesForJobResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateJobPublishedMockHandler = (overrideResponse?: UpdateJobPublishedResult | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<UpdateJobPublishedResult> | UpdateJobPublishedResult), options?: RequestHandlerOptions) => {
  return http.patch('*/employer/job/update-published', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateJobPublishedResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getCloseJobMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.patch('*/employer/job/close', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getFindBestCandidateMockHandler = (overrideResponse?: FindBestCandidateResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<FindBestCandidateResult> | FindBestCandidateResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job/:jobId/find-best-candidate', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getFindBestCandidateResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getReactToBestCandidateMockHandler = (overrideResponse?: ReactToCandidateResult | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<ReactToCandidateResult> | ReactToCandidateResult), options?: RequestHandlerOptions) => {
  return http.post('*/employer/job/react-best-candidate', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getReactToBestCandidateResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetJobNotificationSettingsMockHandler = (overrideResponse?: GetJobNotificationSettingsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetJobNotificationSettingsResult> | GetJobNotificationSettingsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job/:jobId/notification-settings', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobNotificationSettingsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateJobNotificationSettingsMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/job/notification-settings', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getGetJobApplicationMockHandler = (overrideResponse?: GetJobApplicationResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetJobApplicationResult> | GetJobApplicationResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job-application/:jobApplicationId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobApplicationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListAllWaitingJobApplicationsMockHandler = (overrideResponse?: ListAllWaitingJobApplicationsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListAllWaitingJobApplicationsResult> | ListAllWaitingJobApplicationsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job-application', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAllWaitingJobApplicationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListJobApplicationRejectionReasonsMockHandler = (overrideResponse?: ListJobApplicationRejectionReasonsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListJobApplicationRejectionReasonsResult> | ListJobApplicationRejectionReasonsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/job-application/rejection-reasons', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobApplicationRejectionReasonsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getRejectJobApplicationMockHandler = (overrideResponse?: RejectJobApplicationResult | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<RejectJobApplicationResult> | RejectJobApplicationResult), options?: RequestHandlerOptions) => {
  return http.post('*/employer/job-application/reject', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getRejectJobApplicationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getStartMatchMockHandler = (overrideResponse?: StartMatchResult | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<StartMatchResult> | StartMatchResult), options?: RequestHandlerOptions) => {
  return http.post('*/employer/job-application/start-match', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getStartMatchResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getSendCompleteProfileRequestMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/job-application/complete-profile-request', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getBuyCreditsMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/invoice/credits', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getListCreditTransactionsMockHandler = (overrideResponse?: ListCreditTransactionsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListCreditTransactionsResult> | ListCreditTransactionsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/credits', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCreditTransactionsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetSubscriptionMockHandler = (overrideResponse?: GetSubscriptionResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetSubscriptionResult> | GetSubscriptionResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/subscription', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetSubscriptionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListCompanySubscriptionsMockHandler = (overrideResponse?: ListCompanySubscriptionsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListCompanySubscriptionsResult> | ListCompanySubscriptionsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/subscriptions', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListCompanySubscriptionsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListInvoicesForCompanyMockHandler = (overrideResponse?: ListInvoicesForCompanyResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListInvoicesForCompanyResult> | ListInvoicesForCompanyResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListInvoicesForCompanyResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetInvoiceFileUrlMockHandler = (overrideResponse?: GetInvoiceFileUrlResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetInvoiceFileUrlResult> | GetInvoiceFileUrlResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/invoice/:fileId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetInvoiceFileUrlResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListIntegrationsMockHandler = (overrideResponse?: ListIntegrationsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListIntegrationsResult> | ListIntegrationsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/integration', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListIntegrationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getConnectHomerunIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post('*/employer/homerun-connection', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectHomerunIntegrationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateHomerunConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put('*/employer/homerun-connection/:connectionId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateHomerunConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetHomerunConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultHomerunConnectionConfig | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetAtsIntegrationConnectionResultHomerunConnectionConfig> | GetAtsIntegrationConnectionResultHomerunConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get('*/employer/homerun-connection/:connectionId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetHomerunConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getDeleteIntegrationConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.delete('*/employer/integration-connection/:connectionId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDeleteIntegrationConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListAtsJobsMockHandler = (overrideResponse?: ListAtsJobsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListAtsJobsResult> | ListAtsJobsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/integration-connection/ats-jobs/:connectionId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListAtsJobsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getMapJobWithAtsJobMockHandler = (overrideResponse?: Unit | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.post('*/employer/integration-connection/ats-jobs/:connectionId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getMapJobWithAtsJobResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getConnectRecruiteeIntegrationMockHandler = (overrideResponse?: IntegrationConnectionDto | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IntegrationConnectionDto> | IntegrationConnectionDto), options?: RequestHandlerOptions) => {
  return http.post('*/employer/recruitee-connection', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getConnectRecruiteeIntegrationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateRecruiteeConnectionMockHandler = (overrideResponse?: Unit | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.put('*/employer/recruitee-connection/recruitee/:connectionId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateRecruiteeConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetRecruiteeConnectionMockHandler = (overrideResponse?: GetAtsIntegrationConnectionResultRecruiteeConnectionConfig | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetAtsIntegrationConnectionResultRecruiteeConnectionConfig> | GetAtsIntegrationConnectionResultRecruiteeConnectionConfig), options?: RequestHandlerOptions) => {
  return http.get('*/employer/recruitee-connection/recruitee/:connectionId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetRecruiteeConnectionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getCreateEmployerInviteMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/admin/employer/create-employer-invite/employer', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getCreateTeammateInviteMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/admin/employer/create-teammate-invite/teammate', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getListReferralInvitesMockHandler = (overrideResponse?: ListReferralInvitesResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListReferralInvitesResult> | ListReferralInvitesResult), options?: RequestHandlerOptions) => {
  return http.get('*/admin/employer/list-referral-invites', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListReferralInvitesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getDeleteTeammateMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/admin/employer/delete-teammate/teammate', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getGetEmployerAccessMockHandler = (overrideResponse?: GetEmployerAccessResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetEmployerAccessResult> | GetEmployerAccessResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/profile/access', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetEmployerAccessResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetProfileMockHandler = (overrideResponse?: GetEmployerProfileResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetEmployerProfileResult> | GetEmployerProfileResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/profile', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetProfileResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateProfileMockHandler = (overrideResponse?: number | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.patch('*/employer/profile', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateProfileResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetStatisticsMockHandler = (overrideResponse?: GetCompanyStatisticsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetCompanyStatisticsResult> | GetCompanyStatisticsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/dashboard/statistics', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetStatisticsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListUnhandledJobsMockHandler = (overrideResponse?: ListUnhandledJobsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListUnhandledJobsResult> | ListUnhandledJobsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/dashboard/unhandled-jobs', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListUnhandledJobsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListUnhandledMatchesMockHandler = (overrideResponse?: ListUnhandledMatchesResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListUnhandledMatchesResult> | ListUnhandledMatchesResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/dashboard/unhandled-matches', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListUnhandledMatchesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetConferenceInfoMockHandler = (overrideResponse?: GetConferenceInfoResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetConferenceInfoResult> | GetConferenceInfoResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/conference', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetConferenceInfoResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListConferenceChatsEmployerMockHandler = (overrideResponse?: ListConferenceChatsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListConferenceChatsResult> | ListConferenceChatsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/conference/chat', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListConferenceChatsEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getSendConferenceChatMessageEmployerMockHandler = (overrideResponse?: ChatMessageDto | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<ChatMessageDto> | ChatMessageDto), options?: RequestHandlerOptions) => {
  return http.post('*/employer/conference/chat', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendConferenceChatMessageEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListUnreadConferenceChatsEmployerMockHandler = (overrideResponse?: ListUnreadConferenceChatsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListUnreadConferenceChatsResult> | ListUnreadConferenceChatsResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/conference/chat-unread', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListUnreadConferenceChatsEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetConferenceChatWithMessagesForEmployerMockHandler = (overrideResponse?: GetConferenceChatWithMessagesForEmployerResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetConferenceChatWithMessagesForEmployerResult> | GetConferenceChatWithMessagesForEmployerResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/conference/chat/:chatId', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetConferenceChatWithMessagesForEmployerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetMyCompanyMockHandler = (overrideResponse?: GetCompanyFromPortalResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetCompanyFromPortalResult> | GetCompanyFromPortalResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMyCompanyResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateMyCompanyMockHandler = (overrideResponse?: number | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.put('*/employer/company', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateMyCompanyResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getDeleteMyCompanyMockHandler = (overrideResponse?: number | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<number> | number), options?: RequestHandlerOptions) => {
  return http.delete('*/employer/company', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDeleteMyCompanyResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetMyCompanyPlanMockHandler = (overrideResponse?: GetCompanyPlanResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetCompanyPlanResult> | GetCompanyPlanResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company/plan', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMyCompanyPlanResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListEmployersForCompanyMockHandler = (overrideResponse?: ListOtherEmployersForCompanyResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListOtherEmployersForCompanyResult> | ListOtherEmployersForCompanyResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company/employers', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListEmployersForCompanyResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getAddOrUpdateDefaultMessageMockHandler = (overrideResponse?: AddOrUpdateDefaultMessageResult | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<AddOrUpdateDefaultMessageResult> | AddOrUpdateDefaultMessageResult), options?: RequestHandlerOptions) => {
  return http.post('*/employer/company/default-messages', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getAddOrUpdateDefaultMessageResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getDeleteDefaultMessageMockHandler = (overrideResponse?: DeleteDefaultMessageResult | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<DeleteDefaultMessageResult> | DeleteDefaultMessageResult), options?: RequestHandlerOptions) => {
  return http.delete('*/employer/company/default-messages/:id', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDeleteDefaultMessageResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUploadProvisionalImageMockHandler = (overrideResponse?: ImageDto | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<ImageDto> | ImageDto), options?: RequestHandlerOptions) => {
  return http.post('*/employer/company/provisional-image', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUploadProvisionalImageResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getSendRequestToAccountManagerMockHandler = (overrideResponse?: Unit | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<Unit> | Unit), options?: RequestHandlerOptions) => {
  return http.post('*/employer/company/send-account-manager-request', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getSendRequestToAccountManagerResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetCompanyHireReportInfoMockHandler = (overrideResponse?: GetCompanyHireReportInfoResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetCompanyHireReportInfoResult> | GetCompanyHireReportInfoResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/hire-report', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetCompanyHireReportInfoResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getCreateCompanyHireReportMockHandler = (overrideResponse?: CreateCompanyHireReport | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<CreateCompanyHireReport> | CreateCompanyHireReport), options?: RequestHandlerOptions) => {
  return http.post('*/employer/hire-report', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateCompanyHireReportResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getSetMatchingConfigurationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.put('*/employer/company-matching-configuration', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getResetMatchingConfigurationMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.delete>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.delete('*/employer/company-matching-configuration', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getGetMatchingConfigurationMockHandler = (overrideResponse?: GetCompanyMatchingConfigurationResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetCompanyMatchingConfigurationResult> | GetCompanyMatchingConfigurationResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company-matching-configuration', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetMatchingConfigurationResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getRequestLoginLinkMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/authentication/login-link', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getListManagedCompaniesMockHandler = (overrideResponse?: ListManagedCompaniesResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListManagedCompaniesResult> | ListManagedCompaniesResult), options?: RequestHandlerOptions) => {
  return http.get('*/employer/company-admin', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListManagedCompaniesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getUpdateManagedCompanyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/company-admin/update', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getResetManagedCompanyMockHandler = (overrideResponse?: void | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<void> | void), options?: RequestHandlerOptions) => {
  return http.post('*/employer/company-admin/reset', async (info) => {await delay(100);
  if (typeof overrideResponse === 'function') {await overrideResponse(info); }
    return new HttpResponse(null,
      { status: 200,
        
      })
  }, options)
}

export const getListEducationLevelsMockHandler = (overrideResponse?: ListEducationLevelsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListEducationLevelsResult> | ListEducationLevelsResult), options?: RequestHandlerOptions) => {
  return http.get('*/education-level', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListEducationLevelsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListPersonalCharacteristicsMockHandler = (overrideResponse?: ListPersonalCharacteristicsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListPersonalCharacteristicsResult> | ListPersonalCharacteristicsResult), options?: RequestHandlerOptions) => {
  return http.get('*/personal-characteristics', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListPersonalCharacteristicsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListNewJobReasonsMockHandler = (overrideResponse?: ListNewJobReasonsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListNewJobReasonsResult> | ListNewJobReasonsResult), options?: RequestHandlerOptions) => {
  return http.get('*/new-job-reasons', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListNewJobReasonsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListPersonalityTypesMockHandler = (overrideResponse?: ListPersonalityTypesResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListPersonalityTypesResult> | ListPersonalityTypesResult), options?: RequestHandlerOptions) => {
  return http.get('*/personality-types', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListPersonalityTypesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetAutoCompleteLocationsMockHandler = (overrideResponse?: GetAutoCompleteLocationsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetAutoCompleteLocationsResult> | GetAutoCompleteLocationsResult), options?: RequestHandlerOptions) => {
  return http.get('*/location/auto-complete', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetAutoCompleteLocationsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetLocationDetailsMockHandler = (overrideResponse?: GetLocationDetailsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetLocationDetailsResult> | GetLocationDetailsResult), options?: RequestHandlerOptions) => {
  return http.get('*/location/details/v2', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetLocationDetailsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetLocationGeocodeMockHandler = (overrideResponse?: GetLocationGeocodeResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetLocationGeocodeResult> | GetLocationGeocodeResult), options?: RequestHandlerOptions) => {
  return http.get('*/location/location-geocode', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetLocationGeocodeResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListSkillsForInterestsMockHandler = (overrideResponse?: ListSkillsForInterestsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListSkillsForInterestsResult> | ListSkillsForInterestsResult), options?: RequestHandlerOptions) => {
  return http.get('*/skill/v2/list-for-interests', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListSkillsForInterestsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListSkillsForJobCategoriesMockHandler = (overrideResponse?: ListSkillsForJobCategoriesResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListSkillsForJobCategoriesResult> | ListSkillsForJobCategoriesResult), options?: RequestHandlerOptions) => {
  return http.get('*/skill/v2/list-for-job-categories', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListSkillsForJobCategoriesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListJobFunctionsMockHandler = (overrideResponse?: JobFunctionCrudListResult[] | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<JobFunctionCrudListResult[]> | JobFunctionCrudListResult[]), options?: RequestHandlerOptions) => {
  return http.get('*/job-function', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobFunctionsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetJobFunctionMockHandler = (overrideResponse?: JobFunctionCrudJobFunctionDto | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<JobFunctionCrudJobFunctionDto> | JobFunctionCrudJobFunctionDto), options?: RequestHandlerOptions) => {
  return http.get('*/job-function/:id', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobFunctionResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListJobCategoriesMockHandler = (overrideResponse?: JobCategoryCrudListResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<JobCategoryCrudListResult> | JobCategoryCrudListResult), options?: RequestHandlerOptions) => {
  return http.get('*/job-category/v2', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListJobCategoriesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetJobCategoryMockHandler = (overrideResponse?: JobCategoryCrudJobCategoryDto | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<JobCategoryCrudJobCategoryDto> | JobCategoryCrudJobCategoryDto), options?: RequestHandlerOptions) => {
  return http.get('*/job-category/v2/:id', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetJobCategoryResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getListInterestsMockHandler = (overrideResponse?: ListInterestsResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListInterestsResult> | ListInterestsResult), options?: RequestHandlerOptions) => {
  return http.get('*/interest', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListInterestsResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}

export const getGetRoleMockHandler = (overrideResponse?: GetRoleResult | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetRoleResult> | GetRoleResult), options?: RequestHandlerOptions) => {
  return http.get('*/user/account/role', async (info) => {await delay(100);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetRoleResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  }, options)
}
export const getSwipe4WorkEmployerAPIMock = () => [
  getAddUserCommentMockHandler(),
  getGetUserCommentsMockHandler(),
  getEditUserCommentMockHandler(),
  getDeleteUserCommentMockHandler(),
  getListAllSkillsMockHandler(),
  getListEducationLevelsWithTrackCategoryMockHandler(),
  getCreateCompanyForEmployerMockHandler(),
  getListPaymentOptionsMockHandler(),
  getCreateEmployerMockHandler(),
  getGetEmployerOnboardingStatusMockHandler(),
  getListAllMatchesMockHandler(),
  getGetMatchedUserMockHandler(),
  getMarkMatchAsReadOrUnreadMockHandler(),
  getCloseMatchMockHandler(),
  getGetMatchChatWithMessagesForEmployerMockHandler(),
  getSendMatchChatMessageForEmployerMockHandler(),
  getSendPollMockHandler(),
  getGetLeadEmployerMockHandler(),
  getCreateFirebaseAccountForLeadMockHandler(),
  getConvertLeadCompanyToRegularMockHandler(),
  getListJobsMockHandler(),
  getCreateJobMockHandler(),
  getUpdateJobMockHandler(),
  getGetJobMockHandler(),
  getListJobApplicationsForJobMockHandler(),
  getListMatchesForJobMockHandler(),
  getUpdateJobPublishedMockHandler(),
  getCloseJobMockHandler(),
  getFindBestCandidateMockHandler(),
  getReactToBestCandidateMockHandler(),
  getGetJobNotificationSettingsMockHandler(),
  getUpdateJobNotificationSettingsMockHandler(),
  getGetJobApplicationMockHandler(),
  getListAllWaitingJobApplicationsMockHandler(),
  getListJobApplicationRejectionReasonsMockHandler(),
  getRejectJobApplicationMockHandler(),
  getStartMatchMockHandler(),
  getSendCompleteProfileRequestMockHandler(),
  getBuyCreditsMockHandler(),
  getListCreditTransactionsMockHandler(),
  getGetSubscriptionMockHandler(),
  getListCompanySubscriptionsMockHandler(),
  getListInvoicesForCompanyMockHandler(),
  getGetInvoiceFileUrlMockHandler(),
  getListIntegrationsMockHandler(),
  getConnectHomerunIntegrationMockHandler(),
  getUpdateHomerunConnectionMockHandler(),
  getGetHomerunConnectionMockHandler(),
  getDeleteIntegrationConnectionMockHandler(),
  getListAtsJobsMockHandler(),
  getMapJobWithAtsJobMockHandler(),
  getConnectRecruiteeIntegrationMockHandler(),
  getUpdateRecruiteeConnectionMockHandler(),
  getGetRecruiteeConnectionMockHandler(),
  getCreateEmployerInviteMockHandler(),
  getCreateTeammateInviteMockHandler(),
  getListReferralInvitesMockHandler(),
  getDeleteTeammateMockHandler(),
  getGetEmployerAccessMockHandler(),
  getGetProfileMockHandler(),
  getUpdateProfileMockHandler(),
  getGetStatisticsMockHandler(),
  getListUnhandledJobsMockHandler(),
  getListUnhandledMatchesMockHandler(),
  getGetConferenceInfoMockHandler(),
  getListConferenceChatsEmployerMockHandler(),
  getSendConferenceChatMessageEmployerMockHandler(),
  getListUnreadConferenceChatsEmployerMockHandler(),
  getGetConferenceChatWithMessagesForEmployerMockHandler(),
  getGetMyCompanyMockHandler(),
  getUpdateMyCompanyMockHandler(),
  getDeleteMyCompanyMockHandler(),
  getGetMyCompanyPlanMockHandler(),
  getListEmployersForCompanyMockHandler(),
  getAddOrUpdateDefaultMessageMockHandler(),
  getDeleteDefaultMessageMockHandler(),
  getUploadProvisionalImageMockHandler(),
  getSendRequestToAccountManagerMockHandler(),
  getGetCompanyHireReportInfoMockHandler(),
  getCreateCompanyHireReportMockHandler(),
  getSetMatchingConfigurationMockHandler(),
  getResetMatchingConfigurationMockHandler(),
  getGetMatchingConfigurationMockHandler(),
  getRequestLoginLinkMockHandler(),
  getListManagedCompaniesMockHandler(),
  getUpdateManagedCompanyMockHandler(),
  getResetManagedCompanyMockHandler(),
  getListEducationLevelsMockHandler(),
  getListPersonalCharacteristicsMockHandler(),
  getListNewJobReasonsMockHandler(),
  getListPersonalityTypesMockHandler(),
  getGetAutoCompleteLocationsMockHandler(),
  getGetLocationDetailsMockHandler(),
  getGetLocationGeocodeMockHandler(),
  getListSkillsForInterestsMockHandler(),
  getListSkillsForJobCategoriesMockHandler(),
  getListJobFunctionsMockHandler(),
  getGetJobFunctionMockHandler(),
  getListJobCategoriesMockHandler(),
  getGetJobCategoryMockHandler(),
  getListInterestsMockHandler(),
  getGetRoleMockHandler()
]
